import { ChangeDetectorRef, Component, ContentChildren, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { OverflowMenuComponent } from '../overflow-menu/overflow-menu.component';
// prettier-ignore
import { ColDef, ModuleRegistry, SideBarDef, GridReadyEvent, GridApi, ValueFormatterParams, ValueSetterParams, FilterChangedEvent,  RowClassParams, CellValueChangedEvent, GetRowIdParams, FirstDataRenderedEvent, DomLayoutType, DataTypeDefinition, CellEditingStoppedEvent, CellClickedEvent, RowModelType, IServerSideDatasource, IServerSideGetRowsRequest, CellKeyDownEvent, FullWidthCellKeyDownEvent, CellEditingStartedEvent, IRowNode, RowSelectedEvent, ToolPanelDef, ModelUpdatedEvent, GridState, StateUpdatedEvent, ColumnState,  ProcessCellForExportParams, ProcessDataFromClipboardParams, CellRange, RowClassRules, ColGroupDef, CellDoubleClickedEvent, RowNode, RowDragEndEvent, Column, FilterModel } from '@ag-grid-community/core';
import { GridButton, GridOptions, GridColumn, DBGridOptions, GridRow, ChangeState, ServerSideRequestParams, InitGridParams, TTGridState, RowDataChangeEvent, StartCellEditingParams, SaveStateParams, SaveChangesParams, GridReadOptions } from './grid.types';
import { ComponentBaseComponent } from '../component-base/component-base.component';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { AgGridAngular } from '@ag-grid-community/angular';
import { GridLoadingOverlayComponent } from './grid-loading-overlay/grid-loading-overlay.component';
import { Style } from '@app/core/services/core-component.service';
import { UserStore } from '@app/core/services/user.store';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { GridService } from './grid.service';
import { from, BehaviorSubject, Subject, Subscription, debounceTime, switchMap, map, Observer, Observable, takeUntil, groupBy, mergeMap, timer } from 'rxjs';
import { TranslateService } from '@app/core/services/translate.service';
import { DataTaskService } from '@app/core/services/data-task.service';
import { DatataskEvent, ModalEvent, NavigateEvent } from './cell-renderers/grid-functions-cell-renderer/grid-functions-cell-renderer.component';
import { formatDate } from '@angular/common';
import { ProgressModalComponent, ProgressModalData } from './modals/progress-modal/progress-modal.component';
import { UserService } from '@app/core/services/user.service';
import { GridModalData, GridModalService } from './modals/grid-modal.service';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { AG_GRID_LOCALE_EN } from '@ag-grid-community/locale';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { MultiFilterModule } from '@ag-grid-enterprise/multi-filter';
import { DEFAULT_GRID_OPTIONS } from './grid.model';
import { AppSettingsService } from '@app/core/services/app-settings.service';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { DATE_FORMATS, TTDateAdapter } from '@app/core/models/date-adapter';
import { DateFilterSelectionComponent } from './filters/date-filter-selection/date-filter-selection.component';
import { UtilityService } from '@app/core/services/utility.service';
import { ModalService } from '../../services/modal.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LayoutService } from '@app/core/services/layout.service';
import { PrintDialogData, PrintModalComponent } from './modals/print-modal/print-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupService } from '@app/core/services/popup.service';
import { GridDrillDownComponent } from './modals/grid-drill-down/grid-drill-down.component';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { SettingsToolPanelComponent } from './tool-panels/settings-tool-panel/settings-tool-panel.component';
import { GridToolbarComponent } from './toolbar/grid-toolbar/grid-toolbar.component';
import { getAggregateValue, getCellDataType, getDataTaskId, getDecodedFilterModel, getDetailRowNodesFromPivotKeys, getEncodedFilterModel, getFilterModelAsGridFilterSettings, getSortStateAsGridSortSettings, isAggregationRow, isEditableLookup, isErrorOrValidation, isErrorResponse, userSettingsToGridState } from './helpers/grid.helpers';
import { createAutoGroupColumnDef, createDataTypeDefinitions, createDefaultColumnDefinitions, createGridColumnTypes, formatGridColumnValue, GridColumnHelperContext, isGridColumnFilterable, mapGridColumnsToColDefs, preserveCurrentColumnStateInColDefs } from './helpers/grid-column.helpers';
import { applyOptionsFromColschema } from './helpers/grid-colschema-options.helpers';
import { GridPostSaveCoordinator } from './helpers/grid-post-save.coordinator';
import { getRowsWithoutPrimaryKey, getRowUuidsByPrimaryKey, mapDataToGridRows as mapRowsToGridRows, preservePostSaveRowUuids } from './helpers/grid-row-data.helpers';
import { getAutoSaveGroupKey, getPendingChangeRowIdsForState, getPostSaveDatatask, getPostSaveDebounceTime } from './helpers/grid-save.helpers';
import { updateActiveCellEditorFromGridRow } from './helpers/grid-active-editor.helpers';
import { addLoadDataInfoToPagination, addLoadingTextToPagingPanel, addSavingChangesTextToPagingPanel } from './helpers/grid-dom.helpers';
import type { GridPagingDomContext } from './helpers/grid-dom.helpers';

ModuleRegistry.registerModules([ClientSideRowModelModule, ColumnsToolPanelModule, FiltersToolPanelModule, SetFilterModule, ExcelExportModule, RichSelectModule, ServerSideRowModelModule, ClipboardModule, MenuModule, RangeSelectionModule, MultiFilterModule]);

type CellSaveHighlightState = 'pending' | 'saved';

interface CellSaveHighlightEntry {
    state: CellSaveHighlightState;
    token: number;
    timeout?: ReturnType<typeof setTimeout>;
}

interface SaveResponseWithCells<TType extends GridRow = GridRow> {
    node?: IRowNode | null;
    data?: TType | null;
    savedata?: GridRow | null;
    errorcode?: number | string | null;
}

@Component({
    selector: 'tt-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.css'],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
})
export class GridComponent<TType extends GridRow = GridRow> extends ComponentBaseComponent implements OnInit, OnChanges, OnDestroy {
    @ContentChildren(OverflowMenuComponent, { descendants: true })
    public toolbarMenus?: QueryList<OverflowMenuComponent>;

    /**
     * The Grid-configuration object to initialize the grid options with.
     */
    @Input()
    public ttOptions!: GridOptions<TType>;

    /**
     * Event emmited when changes are made to the tt-options object, (like grid-functions being created).
     */
    @Output()
    public ttOptionsChange = new EventEmitter<GridOptions<TType>>();

    /**
     * Event emitted before a modal is opened.
     */
    @Output()
    public ttOpenModal = new EventEmitter<ModalEvent>();

    /**
     * Event emitted when opening print modal.
     */
    @Output()
    public ttOpenPrintModal = new EventEmitter();

    @Output()
    public ttCellDoubleClick = new EventEmitter<CellDoubleClickedEvent>();

    @Output()
    public ttCellClick = new EventEmitter<CellClickedEvent<TType, any>>();

    /**
     * Event emitted before navigating.
     */
    @Output()
    public ttNavigate = new EventEmitter<NavigateEvent>();

    /**
     * Event emitted when a datatask from a button is to be called.
     */
    @Output()
    public ttDatatask = new EventEmitter<DatataskEvent>();

    @Output()
    public ttRowDataChange = new EventEmitter<RowDataChangeEvent<TType>>();

    public onFilterChange = new EventEmitter<FilterModel>();

    public refreshToolbar = new Subject<boolean | void>();

    /**
     * Whether to show a overflow menu on the column headers to open the column context menu.
     *
     * @default false
     */
    @Input()
    public ttShowHeaderMenuButton: boolean = false;

    @Input()
    public set ttRowSelection(value: BooleanInput | 'single' | 'multiple') {
        if (!this.options.kendo) this.options.kendo = {};

        if (typeof value === 'string' && ['single', 'multiple'].includes(value)) {
            this.options.kendo!.selectable = value as 'single' | 'multiple';
        } else {
            this.options.kendo!.selectable = coerceBooleanProperty(value);
        }
    }

    @Output()
    public ttOnRowSelected = new EventEmitter<RowSelectedEvent>();

    @Output()
    public ttOnRead = new EventEmitter<void>();

    @Output()
    public ttOnRebind = new EventEmitter<void>();

    @Output()
    public ttReady = new EventEmitter<boolean>();

    /**
     * Event emitted when displayed row data has changed through sort, filter, tree expand and collapse events.
     */
    @Output()
    public ttModelUpdated = new EventEmitter<ModelUpdatedEvent>();

    /**
     * Handles shortcuts and custom keydown events for grid on document.
     *
     * @param event the keydown event on document.
     */
    @HostListener('document:keydown', ['$event'])
    public async onDocumentKeydown(event: KeyboardEvent) {
        try {
            if (event && this.gridService.isActiveGrid(this.id['grid'])) {
                if (this.postSaveEditingCell === true) {
                    this.recordOpenEditorPostSaveChange();
                }

                if (!!this.rowSelection && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
                    const rowIndex = this.gridApi?.getFocusedCell()?.rowIndex ?? -1;

                    if (event.shiftKey) {
                        this.selectRow(rowIndex, false);
                    } else {
                        this.selectRow(rowIndex);
                    }
                }

                if (this.options.config?.shortcuts === true && event.ctrlKey) {
                    switch (event.code) {
                        case 'KeyI':
                            await this.shortcutInsertRow(event);
                            break;
                        case 'KeyD':
                            await this.shortcutDeleteRows(event);
                            break;
                        default:
                            break;
                    }
                }
            }
        } catch (error) {
            console.log('error :>> ', error);
        }
    }

    /**
     * Grid configuration recieved from database, if any.
     */
    public dbGridOptions?: DBGridOptions;

    /**
     * The merged grid configurations of db and `ttOptions`, linked to the ag-grid component.
     */
    public options: GridOptions<TType> = { ...DEFAULT_GRID_OPTIONS<TType>() };

    /**
     * Reference to this instance's toolbar.
     */
    @ViewChild('toolbar')
    public toolbar!: GridToolbarComponent;

    /**
     * Reference to this instance's AG-grid.
     */
    @ViewChild(AgGridAngular)
    public agGrid?: AgGridAngular;

    /**
     * AG-grid api for this instance of AG-grid.
     */
    public gridApi?: GridApi;

    /**
     * The language texxt to use for in grid.
     */
    public localeText = AG_GRID_LOCALE_EN;

    /**
     * The row model type used for this grid.
     */
    public rowModelType?: RowModelType;

    /**
     * The number of rows to retrieve per request when using server-side row model.
     */
    public cacheBlockSize?: number;

    /**
     * The data-source for server-side row model. Should be kept undefined if row model is client-side.
     */
    public serverSideDataSource?: IServerSideDatasource;

    public excelStyles = this.gridService.excelStyles;

    public destroy$ = new Subject<void>();

    /**
     * Observable for saving the grid state, if `null` then it takes the current state and persists it.
     */
    public rememberGridState$ = new Subject<TTGridState | null>();

    /**
     * Observable fro the redrawing of rows in grid.
     */
    private refreshGrid$ = new Subject<void>();

    /**
     * Observable over the grid's saving state.
     */
    private savingGridData$ = new BehaviorSubject('none');

    private save$ = new Subject<SaveStateParams>();

    /**
     * Observable for (re)initialization of the grid.
     */
    private initializeGrid$ = new Subject<InitGridParams<TType>>();

    /**
     * Observable for reloading data to grid.
     */
    private readData$ = new Subject<{ resolve: (value?: unknown) => void; reject: () => void; showLoadingOverlay?: boolean }>();

    /**
     * Observable for saving changes upon paste event, too many parallell save request will lock tables.
     */
    private pasteSave$ = new Subject<void>();

    private postSaveCoordinator = new GridPostSaveCoordinator({
        getMethod: () => getPostSaveDatatask(this.options),
        getDebounceTime: () => getPostSaveDebounceTime(this.options),
        shouldRunOnSaveError: () => this.options.dataTask?.saveData?.postSaveRunOnSaveError !== false,
        runDatatask: (method) => this.runPostSaveDatatask(method),
        afterRunFinished: () => {
            this.gridApi?.refreshCells({ force: true });
            this.refreshCellEditability();
        },
    });

    private postSaveEditingCell = false;
    private postSaveEditedCellOpen = false;

    private cellSaveHighlights: Record<string, Record<string, CellSaveHighlightEntry>> = {};
    private cellSaveHighlightToken = 0;

    private get postSaveRunning(): boolean {
        return this.postSaveCoordinator.isRunning();
    }

    /**
     * Subscription for listening to changes of mobile theme.
     */
    private mobileThemeSubscription?: Subscription;

    /**
     * Subscription for listening to changed of dekstop theme.
     */
    private desktopThemeSubscription?: Subscription;

    /**
     * The theme of the grid.
     */
    public gridTheme = 'ag-theme-quartz';

    /**
     * Overlay for when the grid is loading data..
     */
    public loadingOverlayComponent = GridLoadingOverlayComponent;

    /**
     * The dom layout for this grid, defining how the height of the grid should be sized.
     */
    public domLayout: DomLayoutType = 'autoHeight';

    /**
     * Sidebar configuration for the grid.
     */
    public sidebarDefinition?: SideBarDef | null | boolean | string | string[] = null;

    /**
     * The HTMLElement used for grid popups so they are not clipped by the grid.
     */
    public popupParent: HTMLElement = document.body;

    /**
     * Icons map of additional icons to make available in grid.
     */
    public icons: { [key: string]: Function | string } = { settings: '<span class="far fa-cog"></span>' };

    /**
     * Custom column types.
     */
    public columnTypes = createGridColumnTypes();

    /**
     * Default settings for columns.
     */
    public defaultColumnDefinitions: ColDef = createDefaultColumnDefinitions({ showHeaderMenuButton: this.ttShowHeaderMenuButton, sortable: this.options.kendo!.sortable });

    /**
     * Default configuration of row groups created with columns side panel.
     */
    public autoGroupColumnDef: ColDef = createAutoGroupColumnDef();

    /**
     * Customs data-types definitions.
     */
    public dataTypeDefinitions: { [cellDataType: string]: DataTypeDefinition } = createDataTypeDefinitions();

    /**
     * The setting for whether grouped columns are locked. Options are `'first' === 1`, `'none' === 0`, or `'all' === 1`.
     *
     * @default 'none' === 0
     */
    public set groupColumnsLocked(lock: 'first' | 'all' | 'none' | null | undefined | -1 | 0 | 1) {
        if (lock === 'first') this._groupColumnsLocked = 1;
        else if (lock === 'all') this._groupColumnsLocked = -1;
        else if (!lock || lock === 'none') this._groupColumnsLocked = 0;
        else this._groupColumnsLocked = lock;
    }
    public get groupColumnsLocked(): -1 | 0 | 1 {
        return this._groupColumnsLocked;
    }
    private _groupColumnsLocked: -1 | 0 | 1 = 0;

    /**
     * The setting for default group expansion.
     *
     * @default 'none' === 0
     */
    public set groupDefaultExpanded(lock: 'first' | 'all' | 'none' | null | undefined | -1 | 0 | 1) {
        if (lock === 'first') this._groupDefaultExpanded = 1;
        else if (lock === 'all') this._groupDefaultExpanded = -1;
        else if (!lock || lock === 'none') this._groupDefaultExpanded = 0;
        else this._groupDefaultExpanded = lock;
    }
    public get groupDefaultExpanded(): -1 | 0 | 1 {
        return this._groupDefaultExpanded;
    }
    private _groupDefaultExpanded: -1 | 0 | 1 = 0;

    /**
     * Returns the current row selection mode.
     */
    public get rowSelection(): 'single' | 'multiple' | undefined {
        return this.options.kendo!.selectable! === true || ((this.options.kendo?.selectable as any) instanceof Object && (this.options.kendo?.selectable as any)?.mode === 'row') ? 'single' : this.options.kendo!.selectable === false ? undefined : this.options.kendo!.selectable;
    }

    public components: { [p: string]: any } = { agDateInput: DateFilterSelectionComponent };

    public rowClassRules: RowClassRules = {
        'tt-grid__row--delete-failed': (params) => params.data?.['_saveFailed'] === true,
    };

    /**
     * Ids of elements in the component.
     */
    public id: { [key: string]: string } = {
        grid: crypto.randomUUID(),
    };

    /**
     * Styling for the grid.
     */
    public style: Style = {
        grid: {},
    };

    /**
     * Translation of text used in this component.
     */
    public translations = {
        grid_functions: '',
        grid_glyphs: '',
        is_selected: '',
        'saving_changes...': '',
        'saved!': '',
        'retrieving_data...': '',
        error_occured: '',
        row_total: '',
        settings: '',
        duplicate_row: '',
    };

    private saveSubscription?: Subscription;
    private popupHost?: HTMLElement;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2,
        private layout: LayoutService,
        private userStore: UserStore,
        public gridService: GridService,
        private translateService: TranslateService,
        private datatask: DataTaskService,
        private userService: UserService,
        private gridModalService: GridModalService,
        public appSettings: AppSettingsService,
        private utility: UtilityService,
        private modalService: ModalService,
        private dateAdapter: TTDateAdapter,
        private dialog: MatDialog,
        private popup: PopupService,
        public cdr: ChangeDetectorRef,
    ) {
        super();

        this.initializeGrid$.pipe(switchMap(this.getPreConfigueInitializeGridObservable), takeUntil(this.destroy$)).subscribe(this.getInitializeGridObserver());
        this.readData$.pipe(takeUntil(this.destroy$), debounceTime(10), switchMap(this.getReadDataObservable)).subscribe(this.getReadDataObserver());
        layout.getMediaQueries().tablet.addEventListener('change', this.setTheme);
        this.setTheme();
        this.rememberGridState$.pipe(takeUntil(this.destroy$), debounceTime(1000)).subscribe((state: TTGridState | null = null) => this.rememberGridState(state));
        this.refreshGrid$.pipe(takeUntil(this.destroy$), debounceTime(500)).subscribe(() => this.gridApi?.redrawRows());
        this.pasteSave$.pipe(takeUntil(this.destroy$), debounceTime(500)).subscribe({ next: this.savePastedChanges });
        this.postSaveCoordinator.createSubscription(this.destroy$);
        this.savingGridData$.pipe(takeUntil(this.destroy$)).subscribe((value) => this.addSavingChangesTextToPagingPanel(value));
        this.saveSubscription = this.createAutoSaveSubscription();
    }

    private saveStateChanges = async (params: SaveStateParams) => {
        console.log('autosave state change >>: ', params.column);
        this.postSaveCoordinator.removeQueuedAutoSave(params);
        const saveSucceeded = await this.saveChanges(params.state, params.rowId ? { rowIds: [params.rowId] } : undefined);

        if (params.state === 'update' && params.rowId && params.params && params.column) {
            const updatedRowData = this.getRowNode({ rowId: params.rowId });
            this.ttRowDataChange.emit({ colId: params.params.column.getColId(), columnInfo: this.options.data!.columnInfo![params.params.column.getColId()], newValue: params.params.newValue, oldValue: params.params.oldValue, row: updatedRowData?.data, saved: true });

            if (!!this.ttOptions.optionfunc && this.ttOptions.optionfunc instanceof Function) {
                this.ttOptions?.optionfunc({ data: { func: 'OnCellClose', postSave: true, ridx: params.params.node?.rowIndex, cidx: this.options.data?.columnDefinitions.indexOf(params.params.colDef), cval: params.column.colname, change: params.params.data[params.column.colname], rdata: params.params.data } });
            }

            if (this.options.dataTask?.saveData?.readAfterSave === true) {
                this.readData();
            }

            this.onFilterChanged();
        }

        this.queueFollowUpAutoSaveIfNeeded(params.state, saveSucceeded, params.rowId);
    };

    private createAutoSaveSubscription(): Subscription {
        return this.save$
            .pipe(
                groupBy((params) => getAutoSaveGroupKey(params)),
                mergeMap((rowSave$) => this.createSerializedRowAutoSaveObservable(rowSave$)),
            )
            .subscribe();
    }

    private createSerializedRowAutoSaveObservable(rowSave$: Observable<SaveStateParams>): Observable<void> {
        return new Observable<void>((observer) => {
            let latestParams: SaveStateParams | null = null;
            let debounceSubscription: Subscription | null = null;
            let saveSubscription: Subscription | null = null;
            let saveRunning = false;

            const clearDebounce = () => {
                debounceSubscription?.unsubscribe();
                debounceSubscription = null;
            };

            const clearSave = () => {
                saveSubscription?.unsubscribe();
                saveSubscription = null;
            };

            const startDebounce = () => {
                clearDebounce();

                debounceSubscription = timer(this.options.dataTask?.saveData?.debounceTime ?? 0).subscribe({
                    next: () => {
                        debounceSubscription = null;

                        const paramsToSave = latestParams;
                        latestParams = null;

                        if (!paramsToSave) {
                            return;
                        }

                        saveRunning = true;
                        const finishSave = () => {
                            saveSubscription = null;
                            saveRunning = false;

                            if (latestParams !== null) {
                                startDebounce();
                            }
                        };

                        saveSubscription = from(this.saveStateChanges(paramsToSave)).subscribe({
                            next: () => observer.next(),
                            error: (error) => {
                                console.error(error);
                                finishSave();
                            },
                            complete: finishSave,
                        });
                    },
                    error: (error) => observer.error(error),
                });
            };

            const sourceSubscription = rowSave$.subscribe({
                next: (params) => {
                    latestParams = params;

                    if (saveRunning !== true) {
                        startDebounce();
                    }
                },
                error: (error) => observer.error(error),
            });

            return () => {
                clearDebounce();
                clearSave();
                sourceSubscription.unsubscribe();
            };
        });
    }

    /**
     * Sets the theme of the grid based on the current screen size and theme set for the screen size.
     */
    private setTheme = () => {
        if (this.layout.getMediaQueries().tablet.matches) {
            this.mobileThemeSubscription?.unsubscribe();
            this.desktopThemeSubscription = this.userStore.themeKeynoChanged.subscribe((keyno) => this.toggleTheme('' + keyno));
        } else {
            this.desktopThemeSubscription?.unsubscribe();
            this.mobileThemeSubscription = this.userStore.themeKeynoMobileChanged.subscribe((keyno) => this.toggleTheme('' + keyno));
        }
    };

    /**
     * Saves all changes forcing single save to be turned on. Too many paralell request, which occurs when cells are pasted will lock tables.
     */
    private savePastedChanges = async () => {
        const oldSingleSetting = this.options.dataTask!.saveData!.single;
        const oldReadAfterAddSetting = this.options.dataTask!.saveData!.readAfterAdd;
        this.options.dataTask!.saveData!.single = true;
        this.options.dataTask!.saveData!.readAfterAdd = false;
        this.gridApi?.showLoadingOverlay();
        try {
            this.mapDirtyRowsToChanges();
            const pastedAddRowIds = this.getPastedAddRowIds();
            const pastedAddDirtyCells = this.getDirtyCellsForRowIds(pastedAddRowIds);
            const pastedAddRowData = this.getPastedRowDataForRowIds(pastedAddRowIds, pastedAddDirtyCells);

            if (pastedAddRowIds.length > 0) {
                await this.saveChanges('add', { await: true, rowIds: pastedAddRowIds });
                this.queuePastedAddRowsAsUpdates(pastedAddRowIds, pastedAddDirtyCells, pastedAddRowData);
            }

            await this.saveAllChanges(true);
        } finally {
            // this.gridApi?.hideOverlay();
            this.options.data!.changes = {};
            this.options.dataTask!.saveData!.single = oldSingleSetting;
            this.options.dataTask!.saveData!.readAfterAdd = oldReadAfterAddSetting;
            this.options.gridfunc?.read();
            this.postSaveCoordinator.clearQueuedPasteSave();
            this.postSaveCoordinator.scheduleCheck();
        }
    };

    private getPastedAddRowIds(): string[] {
        return Object.entries(this.options.data?.changes ?? {})
            .filter(([_, change]) => change.state === 'add' && change.event === 'paste')
            .map(([rowId]) => rowId);
    }

    private getDirtyCellsForRowIds(rowIds: string[]): Map<string, string[]> {
        const dirtyCellsByRowId = new Map<string, string[]>();

        for (const rowId of rowIds) {
            const dirtyCells = this.options.data?.dirtyRows[rowId]?.cells ?? [];

            if (dirtyCells.length > 0) {
                dirtyCellsByRowId.set(rowId, [...dirtyCells]);
            }
        }

        return dirtyCellsByRowId;
    }

    private getPastedRowDataForRowIds(rowIds: string[], dirtyCellsByRowId: Map<string, string[]>): Map<string, Partial<TType>> {
        const pastedRowDataByRowId = new Map<string, Partial<TType>>();

        for (const rowId of rowIds) {
            const rowData = this.options.data?.changes?.[rowId]?.data;
            const dirtyCells = dirtyCellsByRowId.get(rowId) ?? [];

            if (!rowData || dirtyCells.length === 0) continue;

            const pastedRowData = dirtyCells.reduce((data, dirtyCell) => {
                if (dirtyCell !== '_uuid') {
                    data[dirtyCell as keyof TType] = rowData[dirtyCell];
                }

                return data;
            }, {} as Partial<TType>);

            pastedRowDataByRowId.set(rowId, pastedRowData);
        }

        return pastedRowDataByRowId;
    }

    private queuePastedAddRowsAsUpdates(rowIds: string[], dirtyCellsByRowId: Map<string, string[]>, pastedRowDataByRowId: Map<string, Partial<TType>>): void {
        for (const rowId of rowIds) {
            const node = this.getRowNode({ rowId });
            const row = (node?.data ?? this.options.data?.rowData.find((row) => row._uuid === rowId)) as TType | undefined;

            if (!row || row['_saveFailed'] === true) continue;

            const rowIndex = node?.rowIndex ?? null;
            const rowDataIndex = this.options.data?.rowData.findIndex((row) => row._uuid === rowId);
            const updatedRow = { ...row, ...pastedRowDataByRowId.get(rowId), _uuid: row._uuid } as TType;

            if (rowDataIndex !== undefined && rowDataIndex !== -1) {
                this.options.data!.rowData[rowDataIndex] = updatedRow;
            }

            node?.setData(updatedRow);
            this.refreshCellEditability([rowId]);

            this.options.data!.changes![rowId] = {
                state: 'update',
                data: updatedRow,
                rowIndex,
                event: 'paste',
                rowOverId: rowIndex !== null ? (this.getRowNode({ rowIndex: rowIndex + 1 })?.id ?? null) : null,
                direction: null,
            };

            const dirtyCells = dirtyCellsByRowId.get(rowId);

            if (dirtyCells?.length) {
                this.options.data!.dirtyRows[rowId] = { cells: dirtyCells };
                this.markCellsSaveHighlight(rowId, dirtyCells, 'pending');
            }
        }
    }

    /**
     * Gets the classes for the row represented in the given parameters.
     *
     * @param params the parameters to use for retrieving the classes.
     * @returns the classes to apply to the row or `undefined`.
     */
    public getRowClass = (params: RowClassParams) => {
        if (isAggregationRow(params.node)) return 'tt-grid__row--aggregate';

        return undefined;
    };

    /**
     * Gets the row id of the row represented in the given parameters.
     *
     * @param params the parameters to use for retrieving the row id.
     * @returns the row is.
     */
    public getRowId = (params: GetRowIdParams) => params.data?._uuid;

    // #region FOOTER AGGREGATE

    /**
     * Toggles between light theme and dark theme.
     *
     * @param keyno the keyno of the theme (if '1' is light, if not then dark).
     */
    private toggleTheme(keyno: string) {
        if (`${keyno}` === '1') {
            this.gridTheme = 'ag-theme-quartz';
        } else {
            this.gridTheme = 'ag-theme-alpine-dark';
        }
    }

    /**
     * Creates a row with sum aggregate of every number column and sets it as fixed to the bottom..
     */
    private updateAggregationRow() {
        const footerRowData: GridRow & { _id: 'aggregaterow' } = { _id: 'aggregaterow' };
        const rowsToAggregate: TType[] = [];

        if (this.gridApi?.isPivotMode()) {
            this.gridApi?.setGridOption('pinnedBottomRowData', undefined);
            this.gridApi.setGridOption('grandTotalRow', 'bottom');
            return;
        }

        this.gridApi?.setGridOption('grandTotalRow', undefined);

        this.gridApi?.forEachNodeAfterFilter((node) => {
            if (node.isRowPinned() === false && node.group !== true) rowsToAggregate.push(node.data);
        });

        this.options.data!.columnDefinitions.forEach((colDef) => {
            if (this.isDefaultAggregatedColumn(colDef.colId || '')) footerRowData[colDef.colId!] = rowsToAggregate.reduce((sum, row) => sum + (Number(row[colDef.colId!]) || 0), 0);

            if (this.options.kendo?.aggregate && this.options.kendo.aggregate instanceof Array) {
                this.options.kendo.aggregate.forEach((aggregate) => {
                    if (colDef.colId === aggregate.field) {
                        footerRowData[aggregate.field!] = getAggregateValue(aggregate, colDef, rowsToAggregate, footerRowData);
                    }
                });
            }
        });

        if (this.options.kendo?.aggregate) {
            this.gridApi?.setGridOption('pinnedBottomRowData', [footerRowData]);
        } else {
            this.gridApi?.setGridOption('pinnedBottomRowData', undefined);
        }
    }

    /**
     * Checks if the column with the given colId should by default be aggregated.
     * Columns defined with (17,2) from db should by default be aggregated unless aggregation is turned off.
     *
     * @param colId the col-id of the column to check if should be aggregated by default.
     * @returns `true` if the column should be aggregated, `false` if not.
     */
    private isDefaultAggregatedColumn(colId: string) {
        return this.options.data?.columnInfo?.[colId]?.decimalWidth === 17;
    }

    // #endregion FOOTER AGGREGATE

    // #region COLUMN CONFIGURATION

    /**
     * Maps the given list of grid columns to AG-grid ColDef.
     *
     * @param columns the list of columns to map to AG-grid ColDef.
     * @returns a list of objects that can be used for AG-Grid ColDef.
     */
    private mapColumnsToColDef(columns: GridColumn[]): ColDef[] {
        return mapGridColumnsToColDefs(columns, this.getGridColumnHelperContext());
    }

    private getGridColumnHelperContext(): GridColumnHelperContext<TType> {
        return {
            options: this.options,
            ttOptions: this.ttOptions,
            translations: this.translations,
            defaultColumnDefinitions: this.defaultColumnDefinitions,
            excelStyles: this.excelStyles,
            getGridApi: () => this.gridApi,
            datatask: this.datatask,
            rowSelection: this.rowSelection,
            grid: this,
            ttOpenModal: this.ttOpenModal,
            ttNavigate: this.ttNavigate,
            ttDatatask: this.ttDatatask,
            valueSetter: (params, column) => this.valueSetter(params, column),
            getCellSaveHighlightState: (rowId, colId) => this.getCellSaveHighlightState(rowId, colId),
            onCellEditorValueChanged: () => this.onCellEditorValueChanged(),
            onCellKeyDown: (event, keyboardEvent, colname, rowIndex) => this.onCellKeyDown(event, keyboardEvent, colname, rowIndex),
            isEditingLocked: () => this.postSaveRunning,
        };
    }

    /**
     * Sets the new value when a cell has been edited.
     *
     * @param params value setter params.
     * @param column column configuration for the cell that was edited.
     * @returns true if a cell has been edited, false if not.
     */
    private valueSetter(params: ValueSetterParams, column: GridColumn): boolean {
        console.log('params :>> ', params);
        if (this.postSaveRunning === true) return false;

        const pasted = this.prepareValueSetter(params);

        if (params.column.getColId() !== 'is_selected' && !this.valueSetterHasChanged(params, column)) return false;

        this.postSaveCoordinator.recordUserChange();
        this.addDirtyCellsToChanges(params.colDef, params.node!);
        const rowId = params.data['_uuid'];

        if (this.applyValueSetterValue(params) === 'selection') return true;

        this.addValueSetterChangeIfNeeded(params, column);
        this.queueValueSetterAutoSave(params, column, rowId, pasted);

        this.afterValueSetterValueChanged(params, column);

        try {
            if (!!this.ttOptions.config?.onDataChanged && this.ttOptions.config?.onDataChanged instanceof Function) {
                this.ttOptions.config.onDataChanged(params);
            }
        } catch (error) {
            return true;
        }

        return true;
    }

    private prepareValueSetter(params: ValueSetterParams): boolean {
        const pasted = params.context === 'paste';

        this.gridApi?.setGridOption('context', undefined);

        if (params.data['_saveFailed']) {
            delete params.data['_saveFailed'];
        }

        return pasted;
    }

    private applyValueSetterValue(params: ValueSetterParams): 'selection' | 'default' {
        params.data[params.column.getColId()] = params.newValue;

        if (params.column.getColId() === 'is_selected') {
            params.data._dirty = true;
            return 'selection';
        }

        return 'default';
    }

    private addValueSetterChangeIfNeeded(params: ValueSetterParams, column: GridColumn): void {
        if (!this.valueSetterHasChanged(params, column)) return;

        params.data._dirty = true;
        this.addChangeToChanges(params.node!);
    }

    private valueSetterHasChanged(params: ValueSetterParams, column: GridColumn): boolean {
        if (getCellDataType(column) === 'date') {
            return this.getValueSetterDateString(params.newValue) !== this.getValueSetterDateString(params.oldValue);
        }

        // 2025.04.30 EO: Keep false bit-values saveable by comparing string values directly.
        return Array.isArray(params.newValue) || params.newValue?.toString() !== params.oldValue?.toString();
    }

    private getValueSetterDateString(date: unknown): string {
        if (date instanceof Date && date.toString() !== 'Invalid Date') {
            const dateCopy = new Date(date);
            dateCopy.setHours(8);
            return dateCopy.toISOString().substring(0, 10);
        }

        if (typeof date === 'string' && date.trim()) {
            const dateParts = date.split(' ')[0].split('T')[0].split('-');

            if (dateParts.length === 3) {
                const dateCopy = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));
                dateCopy.setHours(8);
                return dateCopy.toISOString().substring(0, 10);
            }
        }

        return '';
    }

    private onCellEditorValueChanged(): void {
        if (this.postSaveRunning === true) return;

        this.recordOpenEditorPostSaveChange();
    }

    private recordOpenEditorPostSaveChange(): void {
        if (this.postSaveEditedCellOpen !== true) {
            this.postSaveEditedCellOpen = true;
            this.postSaveCoordinator.blockForOpenEditedCell();
        }

        this.postSaveCoordinator.recordUserChange();
    }

    private usesCustomPostSaveEditor(event: CellEditingStartedEvent): boolean {
        return typeof event.colDef.cellEditor === 'function';
    }

    private getCellSaveHighlightState(rowId: string | null | undefined, colId: string | null | undefined): CellSaveHighlightState | null {
        if (!rowId || !colId) return null;

        return this.cellSaveHighlights[rowId]?.[colId]?.state ?? null;
    }

    private markCellSaveHighlight(rowId: string | null | undefined, colId: string | null | undefined, state: CellSaveHighlightState, fadeAfterMs?: number): void {
        if (!rowId || !colId || colId.startsWith('_')) return;

        this.cellSaveHighlights[rowId] ??= {};

        const existingHighlight = this.cellSaveHighlights[rowId][colId];
        const token = ++this.cellSaveHighlightToken;

        if (existingHighlight?.timeout) {
            clearTimeout(existingHighlight.timeout);
        }

        this.cellSaveHighlights[rowId][colId] = { state, token };
        this.refreshCellSaveHighlight(rowId, colId);

        if (fadeAfterMs === undefined) return;

        this.cellSaveHighlights[rowId][colId].timeout = setTimeout(() => {
            const highlight = this.cellSaveHighlights[rowId]?.[colId];

            if (highlight?.token !== token || highlight.state !== state) return;

            delete this.cellSaveHighlights[rowId][colId];

            if (Object.keys(this.cellSaveHighlights[rowId]).length === 0) {
                delete this.cellSaveHighlights[rowId];
            }

            this.refreshCellSaveHighlight(rowId, colId);
        }, fadeAfterMs);
    }

    private markCellsSaveHighlight(rowId: string | null | undefined, colIds: Iterable<string>, state: CellSaveHighlightState, fadeAfterMs?: number): void {
        for (const colId of colIds) {
            this.markCellSaveHighlight(rowId, colId, state, fadeAfterMs);
        }
    }

    private refreshCellSaveHighlight(rowId: string, colId: string): void {
        const rowNode = this.getRowNode({ rowId });

        if (!rowNode || !this.gridApi?.getColumn(colId)) return;

        this.gridApi.refreshCells({ rowNodes: [rowNode], columns: [colId], force: true });
    }

    private refreshCellEditability(rowIds?: Iterable<string | null | undefined> | null, colIds?: Iterable<string | null | undefined> | null): void {
        if (!this.gridApi) return;

        const columns = this.getEditableScriptColumnIds(colIds);

        if (columns.length === 0) return;

        const rowNodes = rowIds
            ? Array.from(rowIds)
                  .map((rowId) => (rowId ? this.getRowNode({ rowId }) : null))
                  .filter((node): node is IRowNode => !!node)
            : undefined;

        if (rowIds && rowNodes?.length === 0) return;

        this.gridApi.refreshCells({ rowNodes, columns, force: true });
    }

    private getEditableScriptColumnIds(colIds?: Iterable<string | null | undefined> | null): string[] {
        const candidateColIds = colIds ? Array.from(colIds).filter((colId): colId is string => !!colId) : Object.keys(this.options.data?.columnInfo ?? {});

        return candidateColIds.filter((colId) => !!this.options.data?.columnInfo?.[colId]?.editableScript?.trim() && !!this.gridApi?.getColumn(colId));
    }

    private clearCellSaveHighlights(): void {
        for (const rowHighlights of Object.values(this.cellSaveHighlights)) {
            for (const highlight of Object.values(rowHighlights)) {
                if (highlight.timeout) {
                    clearTimeout(highlight.timeout);
                }
            }
        }

        this.cellSaveHighlights = {};
    }

    private getHighlightedCellIds(rowId: string, state?: CellSaveHighlightState): string[] {
        return Object.entries(this.cellSaveHighlights[rowId] ?? {})
            .filter(([_, highlight]) => !state || highlight.state === state)
            .map(([colId]) => colId);
    }

    private markDirtyRowsAsPending(): void {
        for (const [rowId, dirtyRow] of Object.entries(this.options.data?.dirtyRows ?? {})) {
            this.markCellsSaveHighlight(rowId, dirtyRow.cells, 'pending');
        }
    }

    private getRowDataSnapshotById(): Map<string, GridRow> {
        return new Map((this.options.data?.rowData ?? []).filter((row) => !!row._uuid).map((row) => [row._uuid!, { ...row }]));
    }

    private markSavedCellsFromSaveResponses(responses: unknown, rowDataBeforeSave: Map<string, GridRow>): void {
        if (!Array.isArray(responses)) return;

        const updatedRowIds = new Set<string>();

        for (const response of responses as (SaveResponseWithCells<TType> | null)[]) {
            if (!response || Number(response.errorcode ?? 0) < 0) continue;

            const rowId = response.node?.id ?? response.data?._uuid;

            if (!rowId) continue;

            updatedRowIds.add(rowId);

            const savedCells = new Set<string>(this.getHighlightedCellIds(rowId, 'pending'));
            const previousRowData = rowDataBeforeSave.get(rowId);

            for (const colId of Object.keys(response.savedata ?? {})) {
                if (this.isSaveHighlightColumn(colId) && !this.saveHighlightValuesAreEqual(colId, previousRowData?.[colId], response.savedata?.[colId])) {
                    savedCells.add(colId);
                }
            }

            this.markCellsSaveHighlight(rowId, savedCells, 'saved', 1500);
        }

        this.refreshCellEditability(updatedRowIds);
    }

    private isSaveHighlightColumn(colId: string): boolean {
        return !['_uuid', '_dirty', '_saveFailed', 'xxxoptionsxxx'].includes(colId);
    }

    private saveHighlightValuesAreEqual(colId: string, previousValue: unknown, savedValue: unknown): boolean {
        if (previousValue === savedValue) return true;

        if ((previousValue === null || previousValue === undefined || previousValue === '') && (savedValue === null || savedValue === undefined || savedValue === '')) {
            return true;
        }

        const columnType = this.options.data?.columnInfo?.[colId]?.type;

        if (columnType === 'date' || columnType === 'datetime') {
            const previousDate = this.getSaveHighlightDateTime(previousValue);
            const savedDate = this.getSaveHighlightDateTime(savedValue);

            return previousDate !== null && savedDate !== null && previousDate === savedDate;
        }

        if (this.isNumericSaveHighlightValue(previousValue) && this.isNumericSaveHighlightValue(savedValue)) {
            return Number(previousValue) === Number(savedValue);
        }

        if (typeof previousValue === 'object' || typeof savedValue === 'object') {
            return JSON.stringify(previousValue ?? null) === JSON.stringify(savedValue ?? null);
        }

        return `${previousValue ?? ''}` === `${savedValue ?? ''}`;
    }

    private getSaveHighlightDateTime(value: unknown): number | null {
        if (!value) return null;

        const date = value instanceof Date ? value : new Date(value as string | number | Date);

        return date.toString() !== 'Invalid Date' ? date.getTime() : null;
    }

    private isNumericSaveHighlightValue(value: unknown): boolean {
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
    }

    private queueValueSetterAutoSave(params: ValueSetterParams, column: GridColumn, rowId: string, pasted: boolean): void {
        if (this.options.dataTask?.saveData?.autoSave !== true) return;

        if (pasted) {
            this.postSaveCoordinator.queuePasteSave();
            this.pasteSave$.next();
        } else {
            const saveParams: SaveStateParams = { state: 'update', rowId, params, column };

            this.postSaveCoordinator.queueAutoSave(saveParams);
            this.save$.next(saveParams);
        }
    }

    private queueFollowUpAutoSaveIfNeeded(state: ChangeState, saveSucceeded: boolean, rowId?: string): void {
        if (saveSucceeded !== true || state !== 'update' || this.options.dataTask?.saveData?.autoSave !== true) return;

        const pendingRowIds = getPendingChangeRowIdsForState(this.options, state, rowId);

        for (const pendingRowId of pendingRowIds) {
            const saveParams: SaveStateParams = { state: 'update', rowId: pendingRowId };

            this.postSaveCoordinator.queueAutoSave(saveParams);
            this.save$.next(saveParams);
        }
    }

    private afterValueSetterValueChanged(params: ValueSetterParams, column: GridColumn): void {
        this.updateGridRow(params.data);
        this.refreshCellEditability([params.node?.id]);
        this.onFilterChanged();

        if (!!this.ttOptions.optionfunc && this.ttOptions.optionfunc instanceof Function) {
            this.ttOptions?.optionfunc({ data: { func: 'OnCellClose', postSave: false, ridx: params.node?.rowIndex, cidx: this.options.data?.columnDefinitions.indexOf(params.colDef), cval: column.colname, change: params.data[column.colname], rdata: params.data } });
        }

        this.ttRowDataChange.emit({ colId: params.column.getColId(), columnInfo: this.options.data!.columnInfo![params.column.getColId()], newValue: params.newValue, oldValue: params.oldValue, row: params.data });
    }

    public addDirtyCellsToChanges(colDef: ColDef, node: IRowNode) {
        const rowId = node.id;

        if (!rowId || !colDef.colId) return;

        if (!this.options.data!.dirtyRows[rowId]) {
            this.options.data!.dirtyRows[rowId] = { cells: [] };
        }

        const dirtyCellId = colDef.colId;

        if (!this.options.data!.dirtyRows[rowId].cells.includes(dirtyCellId!)) {
            this.options.data!.dirtyRows[rowId].cells.push(dirtyCellId!);
        }

        this.markCellSaveHighlight(rowId, dirtyCellId, 'pending');
    }

    public addChangeToChanges(node: IRowNode) {
        this.postSaveCoordinator.recordUserChange();

        if (this.options.data!.changes![node!.id!]?.state === 'add') {
            if (this.options.dataTask?.addRow?.autoSave === true && this.options.data!.changes![node!.id!]?.event !== 'paste') {
                // if autosave add row is on it assumes the row has been attempted to be saved and thus calls a update now.
                this.options.data!.changes![node!.id!] = {
                    state: 'update',
                    data: node?.data,
                    rowIndex: node?.rowIndex ?? null,
                    event: 'cellChange',
                    rowOverId: !!node && node.rowIndex !== null ? (this.getRowNode({ rowIndex: node.rowIndex + 1 })?.id ?? null) : null,
                    direction: null,
                };
            } else {
                this.options.data!.changes![node!.id!].data = node?.data;
                this.options.data!.changes![node!.id!].rowIndex = node?.rowIndex ?? null;
                this.options.data!.changes![node!.id!].rowOverId = !!node && node.rowIndex !== null ? (this.getRowNode({ rowIndex: node.rowIndex + 1 })?.id ?? null) : null;
            }
        } else {
            this.options.data!.changes![node!.id!] = {
                state: 'update',
                data: node?.data,
                rowIndex: node?.rowIndex ?? null,
                event: 'cellChange',
                rowOverId: !!node && node.rowIndex !== null ? (this.getRowNode({ rowIndex: node.rowIndex + 1 })?.id ?? null) : null,
                direction: null,
            };
        }
    }

    /**
     * Updates the data source and the grid with the value of the given grid row. Uses _uuid to match the rows so the row can contain changes.
     *
     * @param row the row to update with updated values.
     */
    private updateGridRow(row: TType) {
        const rowIndex = this.options.data?.rowData.findIndex((rowItem) => rowItem?._uuid === row?._uuid);

        if (rowIndex !== undefined && rowIndex !== -1) {
            this.options.data!.rowData[rowIndex] = row;
            this.gridApi?.getRowNode(row._uuid!)?.updateData({ ...row })!;
        }
    }

    // #endregion COLUMN CONFIGURATION

    // #region TOOLBAR

    /**
     * Redraws the current data again.
     */
    private refreshData() {
        this.gridApi?.stopEditing(true);

        setTimeout(() => {
            this.refreshGrid$?.next();
            this.updateAggregationRow();
        });
    }

    private readDataResolve?: (value: unknown) => void;

    /**
     * Fetches row data again and draws it to grid.
     */
    private async readData(options: boolean | GridReadOptions = true) {
        if (this.options.dataTask?.loadData?.loadRows === false) return;

        const showLoadingOverlay = typeof options === 'boolean' ? options : (options.showLoading ?? true);
        const reloadColschema = typeof options === 'boolean' ? this.options.dataTask?.loadData?.reloadColschemaOnRead === true : (options.reloadColschema ?? false);

        if (!!this.readDataResolve) {
            this.readDataResolve([]);
            delete this.readDataResolve;
        }

        const showLoadingWhileReloadingColschema = reloadColschema && this.initializationComplete && showLoadingOverlay;

        if (showLoadingWhileReloadingColschema) {
            this.gridApi?.showLoadingOverlay();
        }

        try {
            if (reloadColschema && this.initializationComplete) {
                await this.setupColumnsFromColschema({ newDataTaskColumns: true });
                await new Promise((resolve, reject) => {
                    this.readDataResolve = resolve;
                    this.readData$.next({ resolve: resolve, reject: reject, showLoadingOverlay: showLoadingOverlay });
                });
            } else if (this.options.dataTask?.loadData?.rebindOnRead && this.initializationComplete) {
                (await this.reloadData(true, true)) as Promise<void>;
            } else {
                if (this.rowModelType === 'serverSide') {
                    this.gridApi?.refreshServerSide();
                } else {
                    await new Promise((resolve, reject) => {
                        this.readDataResolve = resolve;
                        this.readData$.next({ resolve: resolve, reject: reject, showLoadingOverlay: showLoadingOverlay });
                    });
                }
            }
        } catch (error) {
            if (showLoadingWhileReloadingColschema) {
                this.gridApi?.hideOverlay();
            }
            console.error(error);
        }
    }

    /**
     * Function for resolving the rebind promise.
     */
    private reloadDataResolve?: (value?: unknown) => void;

    /**
     * Refetches all data and initializes the grid again.
     */
    private async reloadData(showLoading?: boolean, newDataTaskColumns?: boolean) {
        this.gridStateReady = false;
        this.cdr.markForCheck();

        this.ttOnRebind.emit();

        await this.setupOptionsFromTTOptions({ showLoading: showLoading, newDataTaskColumns: newDataTaskColumns });

        return new Promise((resolve) => (this.reloadDataResolve = resolve));
    }

    /**
     * Updates the default column definition fo the grid.
     *
     * @param newDefaults the new default to update to.
     */
    public updateDefaultColumnDefinition(newDefaults: Partial<ColDef>) {
        const columnState = this.beforeColumnStateUpdate();

        this.defaultColumnDefinitions = { ...this.defaultColumnDefinitions, ...newDefaults };

        this.afterColumnStateUpdate(columnState);
    }

    /**
     * Prepares the grid for columns being updated and returns the current column states of the grid.
     *
     * @returns the current column states of the grid.
     */
    public beforeColumnStateUpdate(): ColumnState[] {
        const columnState = JSON.parse(JSON.stringify(this.gridApi!.getColumnState()));

        this.gridApi?.showLoadingOverlay();
        this.gridApi?.setGridOption('suppressColumnMoveAnimation', true);
        this.gridApi?.setGridOption('animateRows', false);

        return columnState;
    }

    /**
     * Settles the grid after changed to column states. Applies the given column states to grid if provided.
     *
     * @param columnState the column state to update the grid with, if any.
     */
    public afterColumnStateUpdate(columnState?: ColumnState[]) {
        setTimeout(() => {
            if (!!columnState) this.gridApi?.applyColumnState({ state: columnState, applyOrder: true });
            this.enforcePivotColumnOrder();
            this.gridApi?.setGridOption('suppressColumnMoveAnimation', false);
            this.gridApi?.setGridOption('animateRows', true);
            this.gridApi?.hideOverlay();
        });
    }

    /**
     * Opens the print report modal.
     */
    public async openPrintDialog(button?: GridButton) {
        const openModalEvent = {
            preventDefault: () => (openModalEvent.defaultPrevented = true),
            defaultPrevented: false,
            button: button,
        };

        this.ttOpenPrintModal.emit(openModalEvent);

        if (!openModalEvent.defaultPrevented) {
            const dialogRef = this.dialog.open(PrintModalComponent, {
                maxWidth: '95vw',
                width: '150rem',
                height: '95vh',
                data: <PrintDialogData>{
                    load: {
                        ...this.options.dataTask?.loadData,
                        parameters: await this.gridService.getLoadDataParameters(this.ttOptions.dataTask?.loadData?.parameters),
                    },
                    reports: this.options.reports,
                    selected: {
                        rows: this.options.gridfunc?.getSelectedRows(),
                        isSelected: this.options.gridfunc?.getIsSelectedRows(),
                    },
                },
            });

            dialogRef.afterClosed().subscribe((value: boolean) => {
                if (value === true && this.ttOptions.config?.readAfterPrint) {
                    this.options.gridfunc?.read();
                }
            });
        }
    }

    public columnLayoutChanged = false;

    /**
     * Modifies the header and appends the toolbar element.
     */
    private customizeHeaderForToolbar() {
        // @ts-ignore _nativeElement is a property of AgGridAngular
        const root: HTMLDivElement | undefined | null = this.agGrid?._nativeElement.querySelector('.ag-root');
        const header = this.getHeaderElement();

        if (root && header && this.toolbar.elementRef.nativeElement) {
            this.renderer.insertBefore(root, this.toolbar.elementRef.nativeElement, header);
        }
    }

    // #endregion TOOLBAR

    /**
     * Adds load data information, (procedure name and number) to the pagination bar.
     */
    private async addLoadDataInfoToPagination() {
        if ((await this.userService.currentUserDetails()).developMode !== true) return;
        const loadDataMethod = this.options.dataTask?.loadData?.method;

        if (isNaN(Number(loadDataMethod))) return;

        addLoadDataInfoToPagination({
            ...this.getGridPagingDomContext(),
            loadDataMethod,
            loadDataName: (await this.gridService.getLoadMethodName(loadDataMethod! as number)) || '',
        });
    }

    /**
     * Adds a status text indicating that new data is being loaded into the grid.
     *
     * @param show whether to show or hide the status text indicating that data is being loaded.
     */
    private addLoadingTextToPagingPanel(show: boolean) {
        addLoadingTextToPagingPanel({ ...this.getGridPagingDomContext(), show, text: this.translations['retrieving_data...'] });
    }

    /**
     * Adds a status text representing the save-status. Support `'saving' | 'saved' | 'error' | 'none'`.
     *
     * @param saving the status of the save state, supports `'saving' | 'saved' | 'error' | 'none'`.
     */
    private addSavingChangesTextToPagingPanel(saving: string) {
        addSavingChangesTextToPagingPanel({
            ...this.getGridPagingDomContext(),
            saving,
            translations: {
                saving: this.translations['saving_changes...'],
                saved: this.translations['saved!'],
                error: this.translations['error_occured'],
            },
        });
    }

    private getGridPagingDomContext(): GridPagingDomContext {
        return {
            renderer: this.renderer,
            gridElement: (this.agGrid as unknown as { _nativeElement?: HTMLElement })?._nativeElement,
            gridId: this.id['grid'],
            paginationEnabled: this.options.kendo?.pageable ?? true,
        };
    }

    /**
     * Sets the height setting for the grid.
     */
    private setGridHeight() {
        if (this.style['grid']) {
            if (this.options.config?.css?.height === 'fill') {
                this.domLayout = 'normal';
                this.style['grid'].height = '100%';
            } else if (this.options.kendo?.height && typeof (this.options.kendo.height === 'string' || (typeof this.options.kendo.height === 'number' && !isNaN(Number(this.options.kendo?.height))))) {
                this.domLayout = 'normal';
                this.style['grid'].height = typeof this.options.kendo.height === 'string' ? this.options.kendo.height : this.options.kendo.height + 'px';
            } else {
                this.domLayout = 'autoHeight';
                this.style['grid'].height = '100%';
                // delete this.style['grid'].height;
            }
            this.style['grid'].minHeight = this.options.config?.css?.minHeight;
        }
    }

    private async runPostSaveDatatask(method: number): Promise<void> {
        this.gridApi?.refreshCells({ force: true });

        try {
            this.gridApi?.showLoadingOverlay();
            const parameters = await this.gridService.getLoadDataParameters(this.ttOptions.dataTask?.loadData?.parameters);
            const response = await this.datatask.Post(method, { loadDataKeyno: this.ttOptions.dataTask?.loadData?.method, ...parameters });

            if (isErrorOrValidation(response)) {
                if (isErrorResponse(response)) {
                    this.modalService.show({ title: 'error_occured', translateTitle: true, message: response[0]?.errormessage ?? '', type: 'warning' });
                }
            }
        } catch (error) {
            console.error(error);
            //this.modalService.openErrorDialog(`${error}`);
        } finally {
            if (this.options.dataTask?.saveData?.postSaveReadAfter === true) {
                try {
                    await this.readPostSaveDataPreservingUuids();
                } catch (error) {
                    console.error(error);
                }
            }
            this.gridApi?.hideOverlay();
            this.gridApi?.refreshCells({ force: true });
        }
    }

    private async readPostSaveDataPreservingUuids(): Promise<void> {
        const primaryKey = this.options.dataTask?.loadData?.primaryKey;

        if (!primaryKey || this.options.dataTask?.loadData?.reloadColschemaOnRead || this.options.dataTask?.loadData?.rebindOnRead || this.rowModelType === 'serverSide') {
            await this.readData(false);
            return;
        }

        const existingRows = this.options.data?.rowData ?? [];
        const existingRowsWithoutPrimaryKey = getRowsWithoutPrimaryKey(existingRows, primaryKey);
        const rowUuidsByPrimaryKey = getRowUuidsByPrimaryKey(existingRows, primaryKey);

        this.addLoadingTextToPagingPanel(true);

        try {
            const rows = await this.getGridRows();
            const rowsWithPreservedUuids = preservePostSaveRowUuids(rows, primaryKey, rowUuidsByPrimaryKey, existingRows, existingRowsWithoutPrimaryKey, (rowsToMap) => this.mapDataToGridRows(rowsToMap));

            this.setRowData(rowsWithPreservedUuids);
            this.refreshToolbar.next();
            this.updateAggregationRow();
            this.ttOnRead.emit();
            setTimeout(() => this.gridApi?.autoSizeColumns(['grid_functions']));
        } finally {
            this.addLoadingTextToPagingPanel(false);
        }
    }

    private async saveAllChanges(showProgress: boolean = true, progressModalData?: Partial<ProgressModalData>) {
        await new Promise((resolve) => setTimeout(resolve, 0));

        this.mapDirtyRowsToChanges();

        if (Object.keys(this.options.data!.changes!).length < 1) {
            this.savingGridData$.next('none');
            return;
        }

        this.postSaveCoordinator.trackSaveStarted();
        this.savingGridData$.next('saving');
        this.markDirtyRowsAsPending();
        const rowDataBeforeSave = this.getRowDataSnapshotById();

        try {
            const customSaveResponse = await this.gridService.customSave(this.options, 'all');

            this.markSavedCellsFromSaveResponses(customSaveResponse, rowDataBeforeSave);
        } catch (customSaveError) {
            const hasAddChanges = Object.values(this.options.data?.changes ?? {}).some((change) => change.state === 'add');

            if (this.options.dataTask?.saveData?.confirm === true) {
                const result = await this.modalService.openConfirmDialog({ type: 'warning', title: 'ttgrid_modal_save_title', message: 'ttgrid_modal_save_message', ok: 'ttgrid_modal_save_ok', cancel: 'ttgrid_modal_save_cancel' });

                if (result !== true) return;
            }

            let progressModal: ProgressModalComponent | null = null;

            if (showProgress) {
                progressModal = this.modalService.openProgressDialog({ value: 0, max: Object.keys(this.options.data!.changes!).length, rememberId: this.options.dataTask?.rememberId!, showCancel: this.options.progressModalOptions?.showCancelButton, ...progressModalData });
            }

            try {
                const responses = await this.gridService.saveAllChanges(this.options, progressModal, this.gridApi);

                this.markSavedCellsFromSaveResponses(responses, rowDataBeforeSave);

                if (this.options.dataTask?.saveData?.readAfterSave !== false || (this.options.dataTask.saveData.readAfterAdd === true && hasAddChanges)) {
                    this.readData();
                    this.options.data!.changes = {};
                }
                this.savingGridData$.next('saved');
            } catch (error) {
                console.error(error);
                this.postSaveCoordinator.markSaveFailed();
                this.savingGridData$.next('error');
                this.modalService.openErrorDialog(`${error}`);
            } finally {
            }
        } finally {
            this.savingGridData$.next('none');
            this.postSaveCoordinator.trackSaveFinished();
        }
    }

    private mapDirtyRowsToChanges() {
        const dirtyRows = this.options.data?.rowData.filter((row) => row._dirty === true);

        dirtyRows?.forEach((row) => {
            const rowIndex = this.getRowNode({ row })?.rowIndex ?? null;

            if (!this.options.data?.changes?.[row._uuid!]) {
                this.options.data!.changes![row._uuid!] = { state: 'update', data: row, rowIndex, event: 'saveAll', rowOverId: rowIndex !== null ? (this.getRowNode({ rowIndex: rowIndex + 1 })?.id ?? null) : null, direction: null };
            } else if (this.options.data?.changes?.[row._uuid!].data) {
                const rowIndex = this.getRowNode({ row })?.rowIndex ?? null;
                this.options.data!.changes![row._uuid!].data = row;
                this.options.data!.changes![row._uuid!].rowIndex = rowIndex;
                this.options.data!.changes![row._uuid!].rowOverId = rowIndex !== null ? (this.getRowNode({ rowIndex: rowIndex + 1 })?.id ?? null) : null;
            }
        });
    }

    private async shortcutDuplicateRows(event: KeyboardEvent) {
        event.preventDefault();

        if (this.options.config?.allowRowDuplication === true || this.options.config?.specialFunc?.duplicate === true) {
            if (event.shiftKey) {
                await this.duplicateRows({ addBefore: true });
            } else {
                await this.duplicateRows();
            }
        }
    }

    public async duplicateRows(params?: { nodes?: IRowNode[]; addBefore?: boolean }) {
        if (this.postSaveRunning === true) return;

        if (!params) {
            params = { addBefore: false };
        }

        if (!params?.nodes) {
            params.nodes = [];
            const selectedRows = (this.gridApi?.getSelectedRows() ?? []).length > 0 ? this.gridApi!.getSelectedRows() : (this.options.gridfunc?.getIsSelectedRows() ?? []);

            if (selectedRows?.length > 0) {
                for (let row of selectedRows) {
                    const node = this.getRowNode({ row: row });

                    if (!!node) params.nodes.push(node);
                }
            } else {
                const cellRange = this.gridApi?.getCellRanges()?.[0];

                if (cellRange?.startRow?.rowIndex === undefined || cellRange.endRow?.rowIndex === undefined) return;

                params.nodes = [];

                for (let i = cellRange.startRow.rowIndex; i >= cellRange.startRow.rowIndex && i <= cellRange.endRow.rowIndex; i++) {
                    const node = this.getRowNode({ rowIndex: i });

                    if (!!node) params.nodes.push(node);
                }
            }
        }

        let lastIndex = params.nodes.reduce((i, node) => ((node.rowIndex ?? 0) > i ? (i = node.rowIndex!) : i), 0);
        let firstIndex = params.nodes.reduce((i, node) => (node.rowIndex! < i ? (i = node.rowIndex!) : i), lastIndex);

        for (let node of params.nodes ?? []) {
            if (!!node.data) {
                try {
                    const data = JSON.parse(JSON.stringify(node.data));
                    let promise;

                    if (params.addBefore) {
                        promise = this.addRow({ rowItem: data, index: firstIndex++, addBefore: true, event: 'duplicateRow' });
                    } else {
                        promise = this.addRow({ rowItem: data, index: lastIndex++, addBefore: false, event: 'duplicateRow' });
                    }

                    if (this.options.dataTask?.saveData?.single) {
                        await promise;
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }
    }

    /**
     * Adds a new row based on the given data.
     *
     * @param param0 configuration for what and where to add the new row.
     * @returns a promise containing the newly added row, or undefined adding a new row was cancelled.
     */
    public async addRow({ index, rowItem, addBefore = false, confirm = true, event = 'addRow' }: { index?: number; rowItem?: GridRow; addBefore?: boolean; confirm?: boolean; event?: 'addRow' | 'duplicateRow' }): Promise<TType | undefined> {
        if (this.postSaveRunning === true) return;

        if (this.options.dataTask?.addRow?.confirm && confirm === true) {
            const result = await this.modalService.openConfirmDialog({ type: 'warning', title: 'ttgrid_modal_add_title', message: 'ttgrid_modal_add_message', ok: 'ttgrid_modal_add_ok', cancel: 'ttgrid_modal_add_cancel' });

            if (result !== true) {
                return;
            }
        }

        if (!!rowItem) {
            rowItem._uuid = crypto.randomUUID();

            if ('tt_gridrow_id' in rowItem) {
                rowItem['tt_gridrow_id'] = null;
            }
        }

        const insertIndex = this.getInsertIndex({ index, addBefore });
        const row: GridRow = !!rowItem ? { ...rowItem, _uuid: crypto.randomUUID() } : { ...this.createNewRow(), _uuid: crypto.randomUUID() };
        await this.beforeAddRow(row);

        if (this.options.config?.keepSortOnAdd !== true && this.gridApi?.getColumnState().some((columnState) => !!columnState.sort)) {
            this.gridApi?.applyColumnState({ defaultState: { sort: null } });
        }

        this.options.data?.rowData.splice(insertIndex, 0, row as TType);
        this.gridApi?.updateGridOptions({ rowData: this.options.data?.rowData });

        if (!!this.rowSelection) {
            console.log(this.rowSelection);
            console.log('this?');
            this.selectRow(insertIndex);
        }

        const firstEditableColumn = this.getFirstEditableColumnKey(this.gridApi?.getRowNode(row._uuid!)!);

        if (firstEditableColumn) {
            setTimeout(() => {
                this.startCellEditing({ rowId: row._uuid!, columnKey: firstEditableColumn });
            });
        }

        if (this.options.data!.hasGotoParms) {
            row['item_state'] = '';
            row['item_parms'] = '';
            row['item_path'] = '';
        }

        if (this.options.data!.hasThumbnails) {
            row['item_thumb'] = '';
        }

        this.options.data!.changes![row._uuid!] = { state: 'add', data: row as TType, rowIndex: insertIndex, event: event, rowOverId: this.getRowNode({ rowIndex: insertIndex + 1 })?.id ?? null, direction: null };
        this.postSaveCoordinator.recordUserChange();

        if (this.options.dataTask?.addRow?.autoSave === true) {
            await this.saveChanges('add', { rowIds: [row._uuid!] });
        }
        await this.afterAddRow(row, insertIndex);

        if (this.options.dataTask?.addRow?.openEdit && this.gridApi) {
            const node = this.getRowNode({ row: row as TType });

            if (!!node) {
                await this.gridModalService.openRowEditModal(this.options, node, this.gridApi);
            }
        }

        return row as TType;
    }

    /**
     * Removes the given row from the grid row data.
     *
     * @param row the row to remove.
     * @param checkShouldConfirm whether to check if remove should be confirm and if so opens the confirmation modal.
     * @param checkShouldAutoSave whether to check if remove should be auto-save and if so persists changes.
     * @returns empty promise which fullfils once the save is completes.
     */
    private async removeRow(row: TType, checkShouldConfirm: boolean = true, checkShouldAutoSave: boolean = true, runPostRemove: boolean = true) {
        if (this.postSaveRunning === true) return null;

        if (checkShouldConfirm === true) {
            const confirmedRemove = await this.confirmRemoveRow();

            if (confirmedRemove !== true) {
                return null;
            }
        }

        const index = this.options.data?.rowData.findIndex((rowItem) => row._uuid === rowItem._uuid);

        if (index !== undefined && index !== -1) {
            this.options.data?.rowData.splice(index, 1);
            this.postSaveCoordinator.recordUserChange();

            if (this.options.data?.changes?.[row._uuid!]?.state === 'add') {
                delete this.options.data.changes[row._uuid!];
            } else {
                this.options.data!.changes![row._uuid!] = { state: 'remove', data: row, rowIndex: index, event: 'removeRow', direction: null, rowOverId: this.getRowNode({ rowIndex: index + 1 })?.id ?? null };
            }
        }

        if (checkShouldAutoSave === true && this.options.dataTask?.removeRow?.autoSave === true) {
            await this.saveChanges('remove', { rowIds: [row._uuid!] });
        }

        if (runPostRemove) {
            this.afterRemoveRow([row], true);
        }

        return row;
    }

    /**
     * Removes all the currently selected rows. Persists changes only if auto-save for remove is true.
     */
    private async removeSelectedRows() {
        if (this.postSaveRunning === true) return null;

        // const confirmedRemove = ;

        if ((await this.confirmRemoveRow()) !== true) return null;

        const firstSelectedNode = this.gridApi?.getSelectedNodes()?.[0]?.rowIndex;
        let selectedRows = this.getSelectedRowsOrFocusedRow();

        await Promise.all(selectedRows?.map(async (row) => await this.removeRow(row, false, false, false)));

        this.gridApi?.setGridOption('rowData', this.options.data?.rowData);

        if (this.options.dataTask?.removeRow?.autoSave === true) {
            this.saveChanges('remove', { await: true, progress: { show: true, progressModalData: { label: 'tt_grid_deleting_rows', translateLabel: true } } });
        }

        await this.afterRemoveRow(selectedRows);

        if (firstSelectedNode !== undefined && firstSelectedNode !== null) {
            const selectIndex = this.gridApi!.getDisplayedRowCount() > firstSelectedNode ? firstSelectedNode : this.gridApi!.getDisplayedRowCount() - 1;
            if (!!this.options.kendo?.selectable) {
                this.selectRow(selectIndex);
            }

            this.setFocusedCell({ rowIndex: selectIndex, columnIndex: 0 });
        }

        return selectedRows || null;
    }

    private getSelectedRowsOrFocusedRow(): TType[] {
        let selectedRows: TType[] = this.options.gridfunc?.getIsSelectedRows() ?? [];

        if ((!selectedRows || selectedRows.length === 0) && !!this.rowSelection) {
            selectedRows = this.gridApi?.getSelectedRows() ?? [];
        }

        if (!selectedRows || selectedRows.length === 0) {
            const cell = this.gridApi?.getFocusedCell();

            if (cell) {
                const row = this.gridApi?.getDisplayedRowAtIndex(cell.rowIndex);
                if (!!row) selectedRows = [row.data];
            }
        }

        return selectedRows;
    }

    /**
     * Checks if the confirm remove row modal should be opened, and returns true if the user confirmed or confirm not necessary.
     *
     * @returns `true` if user confirmed, or confirmation modal shouldn't open.
     */
    private async confirmRemoveRow() {
        if (this.options.dataTask?.removeRow?.confirm === true) {
            const result = await this.modalService.openConfirmDialog({ type: 'warning', title: 'ttgrid_modal_remove_title', message: 'ttgrid_modal_remove_message', ok: 'ttgrid_modal_remove_ok', cancel: 'ttgrid_modal_remove_cancel' });

            if (result !== true) {
                return false;
            }
        }

        return true;
    }

    /**
     * Calls post function set up in remove row, gives the removed rows as parameters. Updates the grid data to display the changes in rows.
     *
     * @param rows the removed rows.
     */
    private async afterRemoveRow(rows?: TType[], focusCell: boolean = false) {
        if (this.options.dataTask?.removeRow?.post instanceof Function) {
            this.options.dataTask.removeRow.post(rows);
        }

        if (focusCell === true && !!rows) {
            let rowNode = this.getRowNode({ row: rows[0] });

            if (!!rowNode) {
                const colKey = this.getFirstEditableColumnKey(rowNode);
                let rowIndex: number | null = null;

                if (!!this.options.data?.rowData.length && this.options.data.rowData.length <= (rowNode.rowIndex ?? 1)) {
                    rowIndex = this.options.data?.rowData.length - 1;
                } else {
                    rowIndex = rowNode.rowIndex;
                }

                this.setFocusedCell({ rowIndex: rowIndex, columnKey: colKey });
                // this.startCellEditing({rowId:})
            }
        }

        this.gridApi?.setGridOption('rowData', this.options.data?.rowData);
        this.updateAggregationRow();
    }

    /**
     * Gets the index for which to insert a new row at based on the given row index and whether to place the row before or after.
     *
     * @param index the index to place a new row at.
     * @param addBefore whether to add the new row before the given index or after.
     * @return the index to place the new row at.
     */
    private getInsertIndex({ index, addBefore = false }: { index?: number; addBefore?: boolean }) {
        // const selectedRows = this.gridApi?.getSelectedRows();
        const focusedCell = this.gridApi?.getFocusedCell();

        let insertIndex = 0;

        if (index !== undefined && index !== null && !isNaN(Number(index))) {
            if (addBefore !== true) {
                insertIndex = index + 1;
            } else {
                insertIndex = index;
            }
        } else if (!!focusedCell) {
            if (addBefore === true) {
                insertIndex = focusedCell.rowIndex;
            } else {
                insertIndex = focusedCell.rowIndex + 1;
            }
            // }
        } else {
            if (addBefore === true) {
                insertIndex = 0;
            } else {
                insertIndex = this.options.data!.rowData.length;
            }
        }

        return insertIndex;
    }

    /**
     * Starts editing cell on the row matching the given parameters if found in the grid. If no column key is given for row to edit, the
     * first editable column will be used. Note that a row needs to be editable for the cell editing to open.
     *
     * @param params the parameters for the cell to edit.
     */
    private startCellEditing(params: StartCellEditingParams) {
        if (this.postSaveRunning === true) return;

        let rowNode: IRowNode | undefined;

        if ('rowId' in params) {
            rowNode = this.gridApi?.getRowNode(params.rowId);
        } else if ('rowIndex' in params) {
            rowNode = this.gridApi?.getDisplayedRowAtIndex(params.rowIndex);
        } else if ('rowNode' in params) {
            rowNode = params.rowNode;
        }

        if (rowNode) {
            const colKey = !!params.columnKey ? params.columnKey : this.getFirstEditableColumnKey(rowNode);

            if (colKey && rowNode.rowIndex !== null) {
                const page = this.getPageForRowIndex(rowNode.rowIndex);
                this.gridApi?.paginationGoToPage(page);

                this.gridApi?.setFocusedCell(rowNode.rowIndex, colKey);
                this.gridApi?.startEditingCell({ colKey: colKey, rowIndex: rowNode.rowIndex });
                this.gridApi?.clearRangeSelection();
            }
        }
    }

    private getFirstEditableColumnKey(rowNode: IRowNode): string | undefined {
        return this.gridApi?.getColumnState()?.find((colState) => this.gridApi?.getColumn(colState.colId)?.isCellEditable(rowNode) && this.gridApi?.getColumn(colState.colId)?.isVisible() && this.options.data?.columnInfo?.[colState.colId].clickonly !== true)?.colId;
    }

    /**
     * Creates and returns a new row with empty for every colname.
     *
     * @returns a row with empty values for every colname.
     */
    private createNewRow(): TType {
        const row: any = {};

        for (let [colname, { type }] of Object.entries(this.options!.data!.columnInfo!)) {
            if (type === 'date' || type === 'datetime' || type === 'time') {
                row[colname] = new Date();
            } else if (type === 'number') {
                row[colname] = 0;
            } else if (type === 'boolean') {
                row[colname] = false;
            } else if (!!type) {
                row[colname] = '';
            }
        }

        return row;
    }

    /**
     * Calls the pre function, to be used before inserting a new row.
     *
     * @param row the row item which is to be inserted.
     */
    private async beforeAddRow(row: GridRow) {
        if (!!this.options.dataTask?.addRow?.pre && this.options.dataTask.addRow.pre instanceof Function) {
            const response = this.options.dataTask.addRow.pre(row);
            if (response instanceof Promise) await response;
        }
    }

    /**
     * Refreshes grid data after inserting new row and calls post function.
     *
     * @param row the newly inserted row, needs to have `_uuid` attribute to find correct data.
     * @param index the rowindex to start cell editing on.
     */
    private async afterAddRow(row: GridRow, index?: number) {
        if (!!this.options.dataTask?.addRow?.post && this.options.dataTask.addRow.post instanceof Function) {
            const newRow = this.options.data?.rowData.find((item) => row._uuid === item._uuid);
            const response = this.options.dataTask.addRow.post(newRow);

            if (response instanceof Promise) await response;
        }

        this.gridApi?.setGridOption('rowData', this.options.data?.rowData);
        this.refreshCellEditability(row._uuid ? [row._uuid] : undefined);
        this.refreshToolbar.next();
        this.updateAggregationRow();
    }

    /**
     * Saves the changes of the given change state.
     *
     * @param state which state to save.
     * @returns empty promise which fullfills once the changes are persisted.
     */
    public async saveChanges(state: ChangeState, params?: SaveChangesParams): Promise<boolean> {
        let saveSucceeded = false;

        this.postSaveCoordinator.trackSaveStarted();
        this.savingGridData$.next('saving');
        this.markDirtyRowsAsPending();
        const rowDataBeforeSave = this.getRowDataSnapshotById();

        try {
            const customSaveResponse = await this.gridService.customSave(this.options, state);

            this.markSavedCellsFromSaveResponses(customSaveResponse, rowDataBeforeSave);
            saveSucceeded = true;
        } catch (customSaveError) {
            try {
                const responses = await this.gridService.standardSaveChanges(state, this.options, params);

                this.markSavedCellsFromSaveResponses(responses, rowDataBeforeSave);

                saveSucceeded = true;
                this.savingGridData$.next('saved');
            } catch (error) {
                this.postSaveCoordinator.markSaveFailed();
                this.savingGridData$.next('error');

                if ((error instanceof Error && !!error.message?.trim?.()) || (typeof error === 'string' && !!error?.trim?.())) {
                    this.modalService.openErrorDialog(`${error}`);
                }
            }
        } finally {
            this.savingGridData$.next('none');
            this.refreshToolbar.next();
            this.updateAggregationRow();
            this.postSaveCoordinator.trackSaveFinished();
        }

        return saveSucceeded;
    }

    /**
     * Retrieves the grid columns and maps them to column definitions and applies to the grid.
     *
     * @param param0 the values to use for retrieving the grid columns.
     */
    private async getGridColumns({ method, loadDataMethod, params, force }: { method?: null | number | string; loadDataMethod: number; params: any; force?: boolean }) {
        return this.gridService.getGridColumns({ method: !!method === true ? Number(method) : 1999, loadDataMethod: loadDataMethod, params: params, force: force });
    }

    /**
     * Finds the options column and applies the options. Returns the columns without the options column.
     *
     * @param columns the columns which may contain a option column.
     * @returns the list of columns without the option column.
     */
    private addOptionsFromColschema<TType extends GridRow = GridRow>(dbGridOptions: DBGridOptions, options: GridOptions<TType>) {
        applyOptionsFromColschema(dbGridOptions, options, {
            validateStateMethod: (state) => this.validateStateMethod(state),
        });
    }

    /**
     * Configures the sidebar according to configuration set in gridoptions sidebar config.
     */
    private configureSidebar() {
        if (this.options.config?.sidebar?.hidden === true) {
            this.sidebarDefinition = null;
        } else {
            let columnsPanelDefinition: ToolPanelDef | null = null;
            let filterPanelDefinition: ToolPanelDef | null = null;
            let toolPanels: ToolPanelDef[] = [];

            if (this.options.config?.sidebar?.hideColumnsPanel !== true) {
                columnsPanelDefinition = { id: 'columns', labelDefault: 'Columns', labelKey: 'columns', iconKey: 'columns', toolPanel: 'agColumnsToolPanel' };

                if (this.options.config?.sidebar?.hidePivotMode === true) {
                    columnsPanelDefinition.toolPanelParams = { ...columnsPanelDefinition.toolPanelParams, suppressPivots: true, suppressPivotMode: true };
                }
                if (this.options.config?.sidebar?.hideRowGroupPane === true) {
                    columnsPanelDefinition.toolPanelParams = { ...columnsPanelDefinition.toolPanelParams, suppressRowGroups: true };
                }
                if (this.options.config?.sidebar?.hideValuesPane === true) {
                    columnsPanelDefinition.toolPanelParams = { ...columnsPanelDefinition.toolPanelParams, suppressValues: true };
                }

                toolPanels.push(columnsPanelDefinition);
            }

            if (this.options.config?.sidebar?.hideFilterPanel !== true) {
                filterPanelDefinition = { id: 'filters', labelDefault: 'Filters', labelKey: 'filters', iconKey: 'filter', toolPanel: 'agFiltersToolPanel' };
                toolPanels.push(filterPanelDefinition);
            }

            if (this.options.config?.sidebar?.hideSettingsPanel !== true) {
                toolPanels.push({ id: 'tt-settings', iconKey: 'settings', labelKey: 'tt_settings', labelDefault: this.translations['settings'], toolPanel: SettingsToolPanelComponent, toolPanelParams: { grid: this } });
            }

            if (this.options.config?.sidebar?.customPanels && this.options.config.sidebar.customPanels.length > 0) {
                toolPanels.push(...this.options.config.sidebar.customPanels);
            }

            if (toolPanels.length > 0) {
                this.sidebarDefinition = { toolPanels: toolPanels, position: 'left' };
            }
        }
    }

    /**
     * Applies the values of `ttOptions` to the internally used `options`.
     */
    private async setupOptionsFromTTOptions(params?: InitGridParams<TType>): Promise<void> {
        try {
            if (!this.ttOptions) return;

            this.createGridFunctions();

            this.options.progressModalOptions = this.ttOptions.progressModalOptions;

            if (this.options.dataTask?.loadData?.loadRows === false) {
                this.options.data!.rowData = this.ttOptions.data?.rowData ?? [];
            }

            this.options.config!.sidebar = { ...this.options.config!.sidebar, ...this.ttOptions.config!.sidebar };
            this.options.config!.specialFunc = { ...this.options.config!.specialFunc, ...this.ttOptions.config?.specialFunc };

            this.options.config!.tooltip = { ...this.options.config?.tooltip, ...this.ttOptions.config?.tooltip };

            this.options.config!.editColumns = [...(this.ttOptions.config?.editColumns || [])];
            this.options.config!.shortcuts = this.ttOptions.config?.shortcuts ?? false;
            this.options.config!.groupDisplayType = this.ttOptions.config?.groupDisplayType ?? 'multipleColumns';
            this.options.config!.rowGroupingLock = this.ttOptions.config?.rowGroupingLock ?? 'none';
            this.options.config!.suppressGroupCount = this.ttOptions.config?.suppressGroupCount ?? false;
            this.options.config!.pivotMode = this.ttOptions.config?.pivotMode ?? false;
            this.options.config!.enableStrictPivotColumnOrder = this.ttOptions.config?.enableStrictPivotColumnOrder ?? true;
            this.options.config!.groupDefaultExpanded = this.ttOptions.config?.groupDefaultExpanded ?? 'none';

            this.options.config!.toolbar = { ...this.options.config!.toolbar, ...this.ttOptions.config?.toolbar };
            this.options.config!.toolbar.buttons = [...(this.ttOptions.config?.toolbar?.buttons ?? [])];
            this.options.config!.toolbar.toggles = [...(this.ttOptions.config?.toolbar?.toggles ?? [])];

            this.options.config!.serverSideHandling = this.ttOptions.config?.serverSideHandling || false;
            this.options.config!.navigation = { ...this.options.config?.navigation, ...this.ttOptions.config?.navigation };

            this.options.config!.css = { ...this.options.config!.css, ...this.ttOptions.config?.css };
            this.options.excelExportConfig = { ...this.options.excelExportConfig, ...this.ttOptions.excelExportConfig };
            this.options.kendo = { ...this.options.kendo, ...this.ttOptions.kendo };
            this.options.kendo!.height = this.ttOptions.kendo?.height || this.options.kendo!.height;
            this.options.kendo!.aggregate = this.ttOptions.kendo?.aggregate !== undefined && this.ttOptions.kendo?.aggregate !== null ? this.ttOptions.kendo?.aggregate : this.options.kendo!.aggregate!;

            await this.setupColumnsFromColschema(params);

            this.getGridState(this.options.data?.columnDefinitions);

            if (this.options.config?.serverSideHandling === true) {
                this.rowModelType = 'serverSide';
            } else {
                this.rowModelType = 'clientSide';
            }

            this.groupColumnsLocked = this.options.config?.rowGroupingLock;
            this.groupDefaultExpanded = this.options.config?.groupDefaultExpanded;
            this.autoGroupColumnDef.cellRendererParams.suppressCount = this.options.config?.suppressGroupCount ?? false;
            this.defaultColumnDefinitions.wrapText = this.ttOptions.config?.css?.textWrapping ?? false;
            this.defaultColumnDefinitions.sortable = this.options.kendo!.sortable;

            if (!this.isFilterable()) {
                this.options.config!.sidebar!.hideFilterPanel = true;
                this.defaultColumnDefinitions.floatingFilter = false;
            }

            this.configureSidebar();
        } catch (error) {
            this.ttReady.emit(false);
            console.log(error);
        }
    }

    private columnSortStateBeforeSortableDisabled?: ColumnState[];

    public async setupColumnsFromColschema(params?: InitGridParams<TType>) {
        let columns: GridColumn[] = [];

        if (!!this.ttOptions.dataTask?.loadData?.method && (params?.newDataTaskColumns === true || JSON.stringify(this.ttOptions.dataTask.loadData) !== JSON.stringify(this.options.dataTask?.loadData))) {
            const sortableBeforeColschema = this.options.kendo?.sortable !== false;

            this.options.dataTask = { ...this.ttOptions.dataTask };

            let parameters = await this.gridService.getLoadDataParameters(this.ttOptions.dataTask.loadData.parameters);

            columns = (await Promise.all([this.getGridColumns({ method: this.ttOptions.dataTask.loadSetupId, loadDataMethod: Number(this.ttOptions.dataTask.loadData.method), params: parameters, force: true }), this.translate()]))[0];

            const { gridOptions, index } = this.gridService.getDBGridOptions(columns);

            if (gridOptions) {
                this.dbGridOptions = gridOptions;
                columns.splice(index, 1);

                this.addOptionsFromColschema(this.dbGridOptions, this.options);
            }

            const currentColumnState = this.initializationComplete ? this.gridApi?.getColumnState() : undefined;
            const sortableAfterColschema = this.options.kendo?.sortable !== false;
            let columnStateToPreserve = currentColumnState;

            if (!sortableAfterColschema && sortableBeforeColschema && currentColumnState) {
                this.columnSortStateBeforeSortableDisabled = currentColumnState.filter((state) => !!state.sort).map((state) => ({ ...state }));
            } else if (sortableAfterColschema && !sortableBeforeColschema && this.columnSortStateBeforeSortableDisabled && currentColumnState) {
                const previousSortByColumn = new Map(this.columnSortStateBeforeSortableDisabled.map((state) => [state.colId, state]));

                columnStateToPreserve = currentColumnState.map((state) => {
                    const previousSort = previousSortByColumn.get(state.colId);

                    return {
                        ...state,
                        sort: previousSort?.sort ?? null,
                        sortIndex: previousSort?.sortIndex ?? null,
                    };
                });
                delete this.columnSortStateBeforeSortableDisabled;
            }

            this.options.data!.columnDefinitions = this.mapColumnsToColDef(columns);

            if (!!this.saveSubscription) {
                this.saveSubscription.unsubscribe();
                delete this.saveSubscription;
            }

            this.saveSubscription = this.createAutoSaveSubscription();

            if (!!this.ttOptions.onSetup && this.ttOptions.onSetup instanceof Function) {
                const result = this.ttOptions.onSetup(columns, this.options.data!.columnInfo!, this.options.data!.columnDefinitions, this.translations);

                if (result instanceof Promise) await result;
            }

            this.options.data!.columnDefinitions = preserveCurrentColumnStateInColDefs(this.options.data!.columnDefinitions, columnStateToPreserve, sortableAfterColschema);
            this.defaultColumnDefinitions = { ...this.defaultColumnDefinitions, sortable: this.options.kendo!.sortable };

            if (this.initializationComplete) {
                this.gridApi?.setGridOption('defaultColDef', this.defaultColumnDefinitions);
                this.gridApi?.setGridOption('columnDefs', this.options.data!.columnDefinitions);
            }
        }
    }

    /**
     * Retireves the grid data.
     */
    private async getGridRows(parameters?: any) {
        let rows: TType[] = [];

        if (this.ttOptions.dataTask?.loadData?.method && !isNaN(Number(this.ttOptions.dataTask.loadData.method))) {
            let parameters = await this.gridService.getLoadDataParameters(this.ttOptions.dataTask.loadData.parameters);

            rows = await this.gridService.getGridData(Number(this.ttOptions.dataTask.loadData.method), parameters, this.options);

            // rows = this.mapDataToGridRows(rows);
        }

        return rows;
    }

    /**
     * Creates and returns an observable for the pre-configuration of the initialization of the grid.
     *
     * @param params the params to use for the initialization of the grid, if any.
     * @returns an observable for the preconfiguration of the initialization of the grid.
     */
    private getPreConfigueInitializeGridObservable = (params?: InitGridParams<TType>): Observable<InitGridParams<TType> | undefined> => {
        return from(this.preConfigureAgGridWithInitialGridData(params)).pipe(switchMap(() => from(this.getInitialGridData(params))));
    };

    /**
     * Creates and returns an observer object for the initialization of the grid.
     *
     * @returns observe object for the initialzation of the grid.
     */
    private getInitializeGridObserver = (): Partial<Observer<InitGridParams<TType> | undefined>> => {
        return { next: (params) => this.configureAgGridWithInitialGridData(params) };
    };

    /**
     * Creates and returns an observable for the retrieving of new row data.
     *
     * @param param0 object containing resolve and reject.
     * @returns an observable for retrieving of new row data.
     */
    private getReadDataObservable = ({ resolve, reject, showLoadingOverlay }: { resolve: (value?: unknown) => void; reject: () => void; showLoadingOverlay?: boolean }): Observable<{ rows: TType[]; resolve: (value?: unknown) => void; reject: () => void }> => {
        this.addLoadingTextToPagingPanel(true);
        if (showLoadingOverlay !== false) {
            this.gridApi?.showLoadingOverlay();
        }
        return from(this.getGridRows()).pipe(map((result) => ({ rows: result, resolve: resolve, reject: reject })));
    };

    /**
     * Creates and returns an observer object for the retrieving of new row data.
     *
     * @returns observer object for the retrieving of new row data.
     */
    private getReadDataObserver = (): Partial<Observer<{ rows: TType[]; resolve: (value?: unknown) => void; reject: () => void }>> => {
        return {
            next: (responses) => {
                this.setRowData(responses.rows);
                responses.resolve();
                this.refreshToolbar.next();
                this.updateAggregationRow();
                this.addLoadingTextToPagingPanel(false);
                this.gridApi?.hideOverlay();
                this.ttOnRead.emit();
                setTimeout(() => this.gridApi?.autoSizeColumns(['grid_functions']));
            },
        };
    };

    /**
     * Retrieves the grid data server side using the given request parameters.
     *
     * @param requestParams the request parameters to select rows based of.
     * @returns an object containing grid data and total row count.
     */
    private async getGridRowsServerSide(requestParams: IServerSideGetRowsRequest): Promise<{ items: TType[]; total: number }> {
        try {
            let rows: { items: TType[]; total: number } = { items: [], total: 0 };

            if (this.ttOptions.dataTask?.loadData?.method && !isNaN(Number(this.ttOptions.dataTask.loadData.method))) {
                const params: ServerSideRequestParams = {
                    take: requestParams.endRow,
                    skip: requestParams.startRow,
                    filter: getFilterModelAsGridFilterSettings(this.gridApi?.getFilterModel(), true),
                    sort: getSortStateAsGridSortSettings(this.gridApi?.getState().sort) || [],
                    page: this.gridApi?.getState().pagination?.page || 1,
                    pageSize: this.gridApi?.getState().pagination?.pageSize,
                };

                let parameters = await this.gridService.getLoadDataParameters(this.ttOptions.dataTask.loadData.parameters);

                rows = await this.gridService.getGridDataServerSide(Number(this.ttOptions.dataTask.loadData.method), parameters, params);
                rows.items = this.mapDataToGridRows(rows.items);
            }
            return rows;
        } catch (error) {
            throw Error(`${error}`);
        }
    }

    /**
     * Maps the given list of objects to grid rows.
     *
     * @param data the list of data to map as grid rows.
     * @returns a list of grid-rows.
     */
    private mapDataToGridRows(data: Object[]): TType[] {
        return mapRowsToGridRows<TType>(data, this.options.data?.columnDefinitions ?? [], this.options.dataTask?.loadData?.primaryKey);
    }

    private configureServerSideHandling() {
        const _self = this;

        this.cacheBlockSize = 25;

        this.serverSideDataSource = {
            getRows(params) {
                _self
                    .getGridRowsServerSide(params.request)
                    .then((data) => {
                        params.success({ rowData: data.items, rowCount: data.total });
                        setTimeout(() => _self.gridApi?.autoSizeColumns(['grid_functions']));
                    })
                    .catch((_) => params.fail());
            },
        };
    }

    /**
     * To be called before `configurationAgGridWithInitialGridData()` and `getInitialGridData()`. Ensures everything is ready for the configuration of ag-grid.
     *
     * @param params initializing grid parameters.
     */
    private async preConfigureAgGridWithInitialGridData(params?: InitGridParams<TType>) {
        this.initializationComplete = false;
        delete this.dbGridOptions;

        if (params?.setupTTOptions === true || params?.newDataTaskColumns === true) {
            this.setupOptionsFromTTOptions(params);
        }

        if (params?.showLoading !== false) {
            this.gridApi?.showLoadingOverlay();
        }

        try {
            await this.userStore.ensureIsReady();

            this.customizeHeaderForToolbar();

            if (!!this.options?.dataTask?.loadData?.method && !isNaN(Number(this.options.dataTask.loadData.method))) {
                this.addLoadDataInfoToPagination();
            }
        } catch (error) {
            console.log('********************* PRE CONFIGURATION OF TT-GRID FAILED ***************************');
            console.error(error);
        }
    }

    /**
     * Retrieves the initial grid data required for initializing grid. If the grid is a serverside handled grid then the `rowData` will be an empty list, and the serverside data source will be configured instead.
     *
     * @param params initializing grid parameters.
     * @returns a promise resolving an object containing the `columns` and `rowData` for the grid. `rowData` will be empty list if the grid is serversidehandled.
     */
    private async getInitialGridData(params?: InitGridParams<TType>): Promise<InitGridParams<TType> | undefined> {
        try {
            if (!!this.options?.dataTask?.loadData?.method && !isNaN(Number(this.options.dataTask.loadData.method))) {
                if (this.options.config?.serverSideHandling === true) {
                    this.configureServerSideHandling();
                } else {
                    await this.readData();
                }
            }
        } catch (error) {
            console.error('******************** GRID COULD NOT INITIALIZE ********************');
            console.error('error! error! error! error! error!');
            console.error(error);

            let message: string = '';

            if (error instanceof HttpErrorResponse) {
                message = error.message;
            } else if (!!(error as any)?.data?.message) {
                message = (error as any).data.message;

                if (!!(error as any)?.data?.data?.message && typeof (error as any)?.data?.data?.message === 'string' && (error as any).data.message !== (error as any).data.data.message) {
                    message = (error as any).data.data.message;
                }
            } else if (!!(error as any).data?.data?.message) {
                message = (error as any).data.data.message;
            } else {
                message = (error as any).message;
            }

            this.modalService.openErrorDialog(message);
        } finally {
            return params;
        }
    }

    /**
     * Configures the grid using the given grid data.
     *
     * @param data the columns and rowdata to initialize ag grid with.
     */
    private async configureAgGridWithInitialGridData(params?: InitGridParams<TType>) {
        try {
            if (this.options?.config?.specialFunc?.edit) {
                this.options.data!.hasSpecialFuncEdit = true;
            }

            if ((!!this.options.config?.specialFunc?.buttons && this.options.config.specialFunc.buttons.length > 0) || (!!this.options.config?.specialFunc?.groupButtons && this.options.config.specialFunc.groupButtons.length > 0) || this.options.data?.hasSpecialFuncEdit) {
                this.options.data!.hasSpecialFunc = true;
            }

            this.setGridHeight();
            this.translate();

            setTimeout(() => this.gridApi?.autoSizeColumns(['grid_functions']));

            if (!!this.options.kendo?.aggregate) this.gridApi?.onFilterChanged();
        } catch (error) {
            console.log('*************** TT-GRID CONFIGURATION FAILED *******************');
            console.error(error);
            params?.reject?.();
        } finally {
            this.gridApi?.hideOverlay();
            this.ttOptions.reports = this.options.reports;
            this.ttOptions.gridfunc = this.options.gridfunc;
            this.ttOptionsChange.emit(this.ttOptions);
            this.refreshToolbar.next();
            params?.resolve?.();
            this.initializationComplete = true;
            this.ttReady.emit(true);
        }
    }

    private pivotColumnOrderTimeout?: ReturnType<typeof setTimeout>;

    public onGridColumnsChanged(): void {
        if (this.pivotColumnOrderTimeout !== undefined) return;
        // Wait for pivot generation and initial-state restoration to finish.
        this.pivotColumnOrderTimeout = setTimeout(() => {
            this.pivotColumnOrderTimeout = undefined;
            this.enforcePivotColumnOrder();
        });
    }

    private enforcePivotColumnOrder(): void {
        const api = this.gridApi;
        if (this.options.config?.enableStrictPivotColumnOrder === false || !api || api.isDestroyed() || !api.isPivotMode()) return;

        // In AG Grid 31 the generated tree remains sorted even when the displayed
        // columns recover the previous user order and append new pivot values.
        const pivotColumns = api.getPivotResultColumns();
        if (!pivotColumns?.length) return;

        const pivotIds = pivotColumns.map(column => column.getColId());
        const pivotIdSet = new Set(pivotIds);
        const currentIds = api.getAllGridColumns().map(column => column.getColId());
        let index = 0;
        const orderedIds = currentIds.map(id => pivotIdSet.has(id) ? pivotIds[index++] : id);
        if (orderedIds.every((id, i) => id === currentIds[i])) return;

        // Apply only order, retaining widths, visibility, pinning and aggregation.
        api.applyColumnState({ state: orderedIds.map(colId => ({ colId })), applyOrder: true });
    }

    public processPivotResultColDef = (colDef: ColDef) => {
        if (colDef.colId?.startsWith('PivotRowTotal') && (this.gridState?.columnOrder?.orderedColIds.at(-1) === colDef.colId || !this.gridState?.columnOrder?.orderedColIds.find((id) => id === colDef.colId))) {
            colDef.pinned = 'right';
        }
        colDef.valueFormatter = (params: ValueFormatterParams) => formatGridColumnValue(params, null);
    };

    public processPivotResultColGroupDef = (colDef: ColGroupDef) => {
        if (colDef.groupId?.startsWith('PivotRowTotal')) {
            colDef.headerName = this.translations['row_total'];
        }
    };

    public initializationComplete = false;

    public onStateUpdated(event: StateUpdatedEvent) {
        if (event.sources[0] !== 'gridInitializing') this.rememberGridState$.next(null);
        this.updateAggregationRow();
    }

    // #region AG-GRID EVENTS

    /**
     * Stores the state of the current filters when the filter is changed by the user.
     *
     * @param event the filter change event.
     */
    public onFilterChanged(_?: FilterChangedEvent): void {
        this.refreshToolbar.next();
        this.updateAggregationRow();
        this.onFilterChange.emit(this.gridApi!.getFilterModel());
    }

    /**
     * Handles insertion of row on keyboard event.
     *
     * @param event the keyboard event that riggered the insertion of a new row.
     */
    private async shortcutInsertRow(event: KeyboardEvent) {
        event.preventDefault();

        if (event.shiftKey) {
            await this.addRow({ addBefore: true });
        } else if (event.altKey) {
            await this.shortcutDuplicateRows(event);
        } else {
            await this.addRow({ addBefore: false });
        }
    }

    /**
     * Handles deletion of row(s) on keyboard event.
     *
     * @param event the kayboard event which triggered the deletion of row(s).
     */
    private async shortcutDeleteRows(event: KeyboardEvent) {
        event.preventDefault();

        if (this.options.config?.toolbar?.delete === true) {
            await this.removeSelectedRows();
        }
    }

    /**
     * Select the row at the given row-index.
     *
     * @param rowIndex the index of the row to set as selected.
     * @param clearCurrentSelected whether to clear the currently selected rows or not.
     */
    private selectRow(rowIndex: number, clearCurrentSelected: boolean = true) {
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);

        if (!!rowNode) {
            rowNode?.setSelected(true, clearCurrentSelected);
        }
    }

    /**
     * Tabs to the next or previous cell using the given keyboard event.
     *
     * @param event the keyboard event to use for tabbing to the next cell.
     */
    private tabToNextOrPreviousCell(event: KeyboardEvent) {
        if (event.shiftKey) {
            this.gridApi!.tabToPreviousCell(event);
        } else {
            this.gridApi!.tabToNextCell(event);
        }
    }

    /**
     * Checks whether the grid and/or column is filterable. If grid is not filterable a column can not be filterable.
     *
     * @param column optional, column to check if is filterable for this instance of grid.
     * @returns `true` if column and/or grid is filterable, `false` if not.
     */
    private isFilterable(column?: GridColumn) {
        return isGridColumnFilterable(this.options, column);
    }

    /**
     * Returns the first visible and editable column of the grid, `null` if there are no visible editable columns.
     *
     * @returns the first visible editable column of the grid, `null` if there are no visible editable columns.
     */
    private getFirstVisibleEditableColumn(): ColDef | null {
        let colState =
            this.gridApi?.getColumnState().find((colDef) => {
                const columnInfo = this.options.data?.columnInfo?.[colDef.colId || ''];
                return (isEditableLookup(columnInfo?.editable) || columnInfo?.editable === true) && colDef?.hide === false && columnInfo?.clickonly !== true;
            }) ?? null;

        return this.options.data?.columnDefinitions.find((colDef) => colState?.colId === colDef.colId) || null;
    }

    /**
     * Returns the last visible and editable column of the grid, `null` if there are no visible editable columns.
     *
     * @returns the last visible editable column of the grid, `null` if there are no visible editable columns.
     */
    private getLastVisibleEditableColumn(): ColDef | null {
        let colState =
            this.gridApi
                ?.getColumnState()
                .slice()
                .reverse()
                .find((colDef) => {
                    const columnInfo = this.options.data?.columnInfo?.[colDef.colId || ''];
                    return (isEditableLookup(columnInfo?.editable) || columnInfo?.editable === true) && colDef?.hide === false && columnInfo?.clickonly !== true;
                }) ?? null;

        return this.options.data?.columnDefinitions.find((colDef) => colState?.colId === colDef.colId) || null;
    }

    /**
     * Checks whether the cell at the given column and row index is the first editable cell of the grid.
     *
     * @param colId the column name of the column to check if has the position of the first editable cell.
     * @param rowIndex the row index of the cell to check if has the position of the first editable cell.
     * @returns `true` if the cell at the position of the given column and row index is the first editable cell, `false` if not.
     */
    private isFirstEditableCell(colId: string, rowIndex: number | null): boolean {
        const firstEditableColumn = this.getFirstVisibleEditableColumn();

        return !!firstEditableColumn && rowIndex !== null && rowIndex === 0 && colId === firstEditableColumn.colId;
    }

    /**
     * Checks whether the cell at the given column and row index is the last editable cell of the grid.
     *
     * @param colId the column name of the column to check if has the position of the last editable cell.
     * @param rowIndex the row index of the cell to check if has the position of the last editable cell.
     * @returns `true` if the cell at the position of the given column and row index is the last editable cell, `false` if not.
     */
    private isLastEditableCell(colId: string, rowIndex: number | null): boolean {
        const lastEditableColumn = this.getLastVisibleEditableColumn();
        const visibleRowLength = this.gridApi!.getDisplayedRowCount();

        return !!lastEditableColumn && rowIndex !== null && rowIndex === visibleRowLength - 1 && colId === lastEditableColumn.colId;
    }

    /**
     * Adds a new line using the keyboard event and cell key down event.
     *
     * @param shiftKey whether the shiftkey was entered with the event or not.
     * @param colId the name of the column the keyboard event happened on.
     * @param rowIndex the row index of the column the keyboard event happened on.
     * @returns the new row which was added, or null if no row could be added.
     */
    private async addNewLineOnCellKeyDown(shiftKey: boolean, colId: string, rowIndex: number | null): Promise<TType | undefined> {
        let newRow: TType | undefined;

        if (shiftKey === true && this.isFirstEditableCell(colId, rowIndex)) {
            newRow = await this.addRow({ index: 0, addBefore: true });

            if (!!this.rowSelection) {
                this.selectRow(0, true);
            }
        } else if (this.isLastEditableCell(colId, rowIndex)) {
            newRow = await this.addRow({ index: this.gridApi!.getDisplayedRowCount() - 1, addBefore: false });
            if (!!this.rowSelection) {
                this.selectRow(this.gridApi!.getDisplayedRowCount() - 1, true);
            }
        }

        return newRow;
    }

    /**
     * Performs a simulated tab event using the given keyboard event and cell key down event.
     *
     * @param event the keyboard event used to trigger the simulated tab..
     * @param cellKeyDownEvent the cell key down event used to trigger the simulated tab.
     */
    private simulateTabOnCellKeyDown(event: KeyboardEvent, colId: string) {
        this.tabToNextOrPreviousCell(event);

        let focusedCell = this.gridApi!.getFocusedCell();
        let columnInfo = this.options.data!.columnInfo![focusedCell?.column.getColId() || ''];
        let focusedRow = this.getRowNode({ rowIndex: focusedCell?.rowIndex });
        const currentState = this.gridApi?.getState();

        if (focusedRow && focusedCell) {
            while (!!focusedRow && (focusedCell?.column.isCellEditable(focusedRow) !== true || columnInfo.clickonly === true) && !currentState?.columnVisibility?.hiddenColIds.includes(focusedCell?.column.getColId() || '')) {
                this.tabToNextOrPreviousCell(event);

                if (focusedCell === this.gridApi?.getFocusedCell()) {
                    break;
                }

                focusedCell = this.gridApi!.getFocusedCell();
                columnInfo = this.options.data!.columnInfo![focusedCell?.column.getColId() || ''];

                focusedRow = this.getRowNode({ rowIndex: focusedCell?.rowIndex });
            }

            setTimeout(() => {
                if (this.postSaveRunning === true) return;

                this.gridApi?.startEditingCell({ colKey: focusedCell!.column, rowIndex: focusedCell!.rowIndex });
            });
        }
    }

    /**
     * Customize navigation in cell keydown event.
     *
     * @param event the cell keydown event.
     */
    public async onCellKeyDown(event: CellKeyDownEvent | FullWidthCellKeyDownEvent | null, keyboardEvent?: KeyboardEvent, colname?: string, rowIndex?: null | number) {
        if (this.postSaveRunning === true) return;

        if ((!!event && !event.event && event.type !== 'cellKeyDown') || (event === null && !keyboardEvent && !colname) || this.editingCell === false) return;

        if (this.postSaveEditingCell === true) {
            this.recordOpenEditorPostSaveChange();
        }

        const keyEvent = <KeyboardEvent>event?.event || keyboardEvent;
        const colId = (event as CellKeyDownEvent)?.column?.getColId() ?? colname;
        const index = (event as CellKeyDownEvent)?.rowIndex ?? rowIndex ?? null;

        if (!!event && keyEvent.key === 'Tab' && this.options.config?.navigation?.newLine === true) {
            this.addNewLineOnCellKeyDown(keyEvent.shiftKey, colId, index);
        } else if (keyEvent.key === 'Enter') {
            this.handleCellKeydownNavigation(keyEvent, colId, index);
        }
    }

    /**
     * Handles special navigation which should occur on keydown events on a cell.
     *
     * @param event the keyboard event of the cell key-down event.
     * @param colId the colunm name of the column were the cell key-down event occured.
     * @param rowIndex the index of the row where the cell key-down event occured.
     */
    private async handleCellKeydownNavigation(event: KeyboardEvent, colId: string, rowIndex: number | null) {
        if (this.gridApi?.getGridOption('context') === 'lookup.popup') {
            this.gridApi.setGridOption('context', undefined);
            return;
        }

        let row: TType | undefined;

        if (this.options.config?.navigation?.newLine === true && ((this.isLastEditableCell(colId, rowIndex) && event.shiftKey === false) || (this.isFirstEditableCell(colId, rowIndex) && event.shiftKey === true))) {
            row = await this.addNewLineOnCellKeyDown(event.shiftKey, colId, rowIndex);
        }

        if (this.options.config?.navigation?.altNav === true && !row) {
            this.simulateTabOnCellKeyDown(event, colId);
        } else if (rowIndex !== null && !row) {
            setTimeout(() => {
                let rowNode;

                if (event.shiftKey) {
                    rowNode = this.getRowNode({ rowIndex: rowIndex - 1 });
                } else {
                    rowNode = this.getRowNode({ rowIndex: rowIndex + 1 });
                }

                if (!rowNode?.id) return;
                this.startCellEditing({ rowId: rowNode.id, columnKey: colId });
            });
        }
    }

    /**
     * Handles cell click event.
     *
     * @param event the cell click event.
     */
    public onCellClicked(event: CellClickedEvent) {
        this.ttCellClick.emit(event);

        const row = event.eventPath?.find((target) => target instanceof HTMLElement && target.getAttribute('row-id') === event.node.id);

        let clickedCell = { dataItem: event.data, column: event.colDef, row: row };

        if (this.ttOptions.optionfunc instanceof Function) {
            this.ttOptions.optionfunc({ data: { func: 'CellClickHandler', clickedCell: clickedCell, options: this.options } });
        }
    }

    private async saveModalRowReadState(event: CellDoubleClickedEvent, modalResult: unknown) {
        if (!event.node?.id || !event.data) return;

        const resultRow = this.getModalResultRow(modalResult);

        if (!resultRow) return;

        Object.keys(resultRow).forEach((key) => {
            if (key !== '_uuid' && key in event.data) {
                event.data[key] = resultRow[key];
            }
        });

        event.data._dirty = true;
        this.addDirtyCellsToChanges(event.colDef, event.node);

        this.options.data!.changes![event.node.id] = {
            state: 'read',
            data: event.data,
            rowIndex: event.node.rowIndex,
            event: 'cellChange',
            rowOverId: event.node.rowIndex !== null ? (this.getRowNode({ rowIndex: event.node.rowIndex + 1 })?.id ?? null) : null,
            direction: null,
        };

        const saved = await this.saveChanges('read', { await: true, rowIds: [event.node.id] });

        if (saved) {
            event.node.data._dirty = false;
            this.updateGridRow(event.node.data);
        }
    }

    private getModalResultRow(modalResult: unknown): GridRow | null {
        if (!modalResult || typeof modalResult !== 'object') return null;

        const result = modalResult as Record<string, unknown>;

        return !!result['savedata'] && typeof result['savedata'] === 'object' ? (result['savedata'] as GridRow) : (result as GridRow);
    }

    public async onCellDoubleClicked(event: CellDoubleClickedEvent) {
        this.ttCellDoubleClick.emit(event);

        if (this.gridApi?.isPivotMode()) {
            const pivotKeys = event.colDef.pivotKeys ?? [];
            const rootNode = <RowNode>event.node;

            // @ts-ignore
            this.dialog.open(GridDrillDownComponent, { data: { options: this.options, rows: getDetailRowNodesFromPivotKeys(rootNode, pivotKeys).map((i) => i.data) }, height: '80vh', width: '80vw' });

            return;
        }

        const cellDoubleClick = this.options.config?.specialFunc?.cellDoubleClicks?.find((doubleClick) => doubleClick.colname === event.colDef.colId);

        if (!cellDoubleClick) return;

        if (cellDoubleClick.type === 'modal') {
            const modalEvent: ModalEvent = {
                preventDefault: () => (modalEvent.defaultPrevented = true),
                defaultPrevented: false,
                modalComponent: cellDoubleClick.component || '',
                modalSize: 'pst-ninetyfive',
                rowData: event.data,
            };

            // this.ttOpenModal.emit(modalEvent);

            if (modalEvent.defaultPrevented) return;

            let modalResult: unknown;

            if (cellDoubleClick.component === 'StateDialog') {
                let state = '';
                let params = '';
                const response = await this.gridService.getGotoParms({ loadDataTask: this.ttOptions.dataTask?.loadData, field: `modal:${cellDoubleClick.colname}`, row: event.data, rememberId: this.ttOptions.dataTask?.rememberId, colgroup: '', rowkey: '' });

                if (!!response.item_state) {
                    state = response.item_state;
                    params = response.item_parms;

                    console.log(params);

                    modalResult = await this.modalService.openStateDialog({ state: state, params: params });
                }
            } else {
                modalResult = await this.gridModalService.openDialogFromDbButton(cellDoubleClick, <GridModalData>{
                    loadData: this.options.dataTask?.loadData,
                    rememberId: this.options.dataTask?.rememberId,
                    selectedRows: this.options.gridfunc?.getIsSelectedRows() || [],
                    row: event.data,
                });
            }

            if (cellDoubleClick.update_row_on_close) {
                await this.saveModalRowReadState(event, modalResult);
            } else if (cellDoubleClick.rebind_on_close === true) {
                this.options.gridfunc?.rebind();
            } else if (cellDoubleClick.read_on_close !== false) {
                this.options.gridfunc?.read();
            }
        } else if (cellDoubleClick.type === 'popup') {
            let state = '';
            let params = '';
            const response = await this.gridService.getGotoParms({ loadDataTask: this.ttOptions.dataTask?.loadData, field: `popup:${cellDoubleClick.colname}`, row: event.data, rememberId: this.ttOptions.dataTask?.rememberId, colgroup: '', rowkey: '' });

            if (!!response.item_state) {
                state = response.item_state;
                params = response.item_parms;
            }

            if (!!state) {
                const popup = await this.popup.openPopup(state + (!!params ? '/' + params : ''), { rememberId: !!this.ttOptions.dataTask?.rememberId ? `${this.ttOptions.dataTask.rememberId}.cellclick:${cellDoubleClick.colname}` : undefined });

                popup?.closed.subscribe((val) => {
                    if (val === true) {
                        if (cellDoubleClick?.rebind_on_close === true) {
                            this.options.gridfunc?.rebind?.();
                        } else if (cellDoubleClick.read_on_close !== false) {
                            this.options.gridfunc?.read?.();
                        }
                    }
                });
            }
        } else if (cellDoubleClick.type === 'datatask') {
            if (!cellDoubleClick.p2_datatask_keyno || cellDoubleClick.p2_datatask_keyno < 1) return;

            const datataskEvent: DatataskEvent = {
                preventDefault: () => (datataskEvent.defaultPrevented = true),
                defaultPrevented: false,
                p2_datatask_keyno: cellDoubleClick.p2_datatask_keyno,
                newTab: !!event.event ? this.utility.isModifierKeyPressed(event.event as KeyboardEvent | MouseEvent) : false,
                rowData: event?.data,
            };

            this.ttDatatask.emit(datataskEvent);

            if (datataskEvent.defaultPrevented) return;

            try {
                this.gridService.dbButtonDatatask({
                    button: cellDoubleClick,
                    parameters: {
                        colgroup: event?.node?.field,
                        rowkey: event?.node?.key,
                        dataItem: event.data,
                        rows: this.gridApi?.getSelectedRows(),
                        isSelected: this.options.gridfunc?.getIsSelectedRows(),
                    },
                    datataskEventEmitter: this.ttDatatask,
                    navigateEventEmitter: this.ttNavigate,
                    event: event.event as MouseEvent,
                    options: this.options,
                });
            } catch (error) {
                this.modalService.openErrorDialog(`${error}`);
            }
        }
    }

    /**
     * Marks the cell of the given event as dirty.
     *
     * @param event the event of the cell that was changed to mark as dirty.
     */
    public onCellValueChanged(event: CellValueChangedEvent) {
        let editedRow = this.options.data?.rowData.findIndex((row) => row._uuid === event.data._uuid);

        if (editedRow !== -1) {
            this.options.data!.rowData[editedRow!] = event.data;
        }
    }

    private editingCell = false;
    /**
     * Checks if the cell is clickonly or not and then navigates accordingly.
     *
     * @param event the cell editing start event.
     */
    public onCellEditingStarted(event: CellEditingStartedEvent) {
        if (this.postSaveRunning === true) {
            this.gridApi?.stopEditing(true);
            return;
        }

        this.postSaveEditingCell = !this.usesCustomPostSaveEditor(event);
        this.postSaveEditedCellOpen = false;

        setTimeout(() => (this.editingCell = true));

        if (event.event && (event.event as KeyboardEvent)?.key === 'Tab' && this.options.data?.columnInfo?.[event.column.getColId()].clickonly === true) {
            if ((event.event as KeyboardEvent).shiftKey === true) {
                this.gridApi?.tabToPreviousCell(event.event as KeyboardEvent);
            } else {
                this.gridApi?.tabToNextCell(event.event as KeyboardEvent);
            }
        }
    }

    /**
     *
     *
     * @param event
     */
    public onCellEditingStopped(event: CellEditingStoppedEvent) {
        let column = this.options.data?.columnDefinitions.find((column) => column.field === event.column.getColId());

        if (!!this.ttOptions.optionfunc && this.ttOptions.optionfunc instanceof Function) {
            if (event.colDef.cellDataType === 'boolean') {
                this.ttOptions.optionfunc({ data: { func: 'CheckboxBoxClick', dataItem: event.data, key: event.colDef.colId, row: event.node.uiLevel } });
            }

            if (!!column && !!column.field && !!this.ttOptions.optionfunc && this.ttOptions.optionfunc instanceof Function) {
                this.ttOptions?.optionfunc({ data: { func: 'OnCellClose', ridx: event.rowIndex, cidx: this.options.data?.columnDefinitions.indexOf(column), cval: column.field, change: event.data[column.field], rdata: event.data } });
            }
        }
        const shouldUnblockOpenEditedCell = this.postSaveEditedCellOpen;

        setTimeout(() => {
            this.editingCell = false;
            this.postSaveEditingCell = false;
            this.postSaveEditedCellOpen = false;
            if (shouldUnblockOpenEditedCell === true) {
                this.postSaveCoordinator.unblockForOpenEditedCell();
            }
            this.postSaveCoordinator.scheduleCheck();
        });

        this.refreshToolbar.next();
    }

    /**
     * Uses onSelect callback to notify about selection change.
     *
     * @param event the row selections event.
     */
    public onRowSelected(event: RowSelectedEvent) {
        this.ttOnRowSelected.emit(event);

        if (!!this.ttOptions?.onSelect && this.ttOptions.onSelect instanceof Function) {
            if (event.node.isSelected()) {
                this.ttOptions.onSelect({ $event: event, $item: event.node.data });
            } else {
                this.ttOptions.onSelect({ $event: event });
            }
        }

        if (!!this.ttOptions.optionfunc && this.ttOptions.optionfunc instanceof Function) {
            const data = { data: { func: 'OnChange', change: event } };

            this.ttOptions.optionfunc(data);
        }
        this.refreshToolbar.next();
    }

    public onRowDragEnd(event: RowDragEndEvent) {
        if (this.postSaveRunning === true) return;

        console.log(event);
        console.log(event.vDirection);
        this.postSaveCoordinator.recordUserChange();
        this.options.data!.changes![event.node.id!] = {
            state: 'update',
            data: event.node.data,
            rowIndex: event.node.rowIndex,
            event: 'rowDrag',
            rowOverId: event.node.rowIndex !== null ? (this.getRowNode({ rowIndex: event.node.rowIndex + 1 })?.id ?? null) : null,
            direction: event.vDirection,
        };

        if (this.options.dataTask?.saveData?.autoSave === true) {
            this.saveChanges('update');
        }
    }

    public async onFirstDataRendered(event: FirstDataRenderedEvent) {
        this.restoreInitialPaginationState();
        this.onGridColumnsChanged();

        if (!!this.ttOptions?.onDataBound && this.ttOptions.onDataBound instanceof Function) {
            this.ttOptions.onDataBound(event);
        }
    }

    public onModelUpdated(event: ModelUpdatedEvent) {
        this.ttModelUpdated.emit(event);

        try {
            if (!!this.ttOptions.onDataBinding && this.ttOptions.onDataBinding instanceof Function) {
                this.ttOptions.onDataBinding(event);
            }
        } catch (error) {
            console.error(error);
        }
    }

    public setOnGridPreDestroyedRemember() {
        this.gridApi?.setGridOption('onGridPreDestroyed', (event) => {
            this.rememberGridState$.next({ ...JSON.parse(JSON.stringify(event.state)), agGrid: true, floatingFilter: this.defaultColumnDefinitions.floatingFilter });
            this.gridApi = undefined;
        });
    }

    public async onGridReady($event: GridReadyEvent) {
        this.gridApi = $event.api;
        this.setOnGridPreDestroyedRemember();

        if (this.ttOptions && !this.columnLayoutChanged) {
            this.initializeGrid$.next({ setupTTOptions: false, resolve: this.reloadDataResolve });
            this.ttOptions.gridfunc = this.options.gridfunc;
        } else if (this.columnLayoutChanged) {
            this.customizeHeaderForToolbar();
            this.gridApi.setGridOption('rowData', this.options.data?.rowData);
            this.addLoadDataInfoToPagination();
            this.gridApi.hideOverlay();
            this.columnLayoutChanged = false;
        }

        this.updateAggregationRow();

        const header = this.getHeaderElement();

        if (!header) return;

        header.addEventListener('click', this.headerTranslateClick, true);
    }

    private headerTranslateClick = async (event: MouseEvent) => {
        if (this.utility.isModifierKeyPressed(event, true)) {
            const headerCell = (event.target as HTMLElement)?.closest('.ag-header-cell');

            if (!headerCell || !('__agComponent' in headerCell) || !headerCell?.__agComponent || !(typeof headerCell.__agComponent === 'object') || !('column' in headerCell?.__agComponent)) return;

            const column = headerCell?.__agComponent?.column as Column;
            const wordId = this.options.data?.columnInfo?.[column.getColId()]?.colname;
            const textToTranslate = this.options.data?.columnInfo?.[column.getColId()]?.title;

            if (!!wordId && !!textToTranslate) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                const response = await this.modalService.openTranslationDialog({ word_id: wordId, textToTranslate: textToTranslate, heading: `Column - ${wordId}` });

                if (!!response) this.options.gridfunc?.rebind();
            }
        }
    };

    // #endregion AG-GRID EVENTS

    private async translate() {
        const translations = await this.translateService.translateBatch(this.translations);

        for (let k of Object.keys(this.translations)) {
            let key: keyof typeof this.translations = k as keyof typeof this.translations;

            if (!!translations[key]) this.translations[key] = translations[key];
        }
    }

    private validateStateMethod(state: ChangeState) {
        const dataTaskId = getDataTaskId(state);

        if (dataTaskId === null) return;

        if (!this.options.dataTask || typeof this.options.dataTask !== 'object') {
            this.options.dataTask = {};
        }

        this.options.dataTask[dataTaskId] ??= { method: 2219, parameters: {} };
        this.options.dataTask[dataTaskId]!.parameters ??= {};

        if (!(this.options.dataTask[dataTaskId]?.method instanceof Function)) {
            if (!!this.options.dataTask[dataTaskId]?.method && !isNaN(Number(this.options.dataTask[dataTaskId]?.method))) {
                this.options.dataTask[dataTaskId]!.method = parseInt(`${this.options.dataTask[dataTaskId]?.method}`, 10);
            } else {
                this.options.dataTask[dataTaskId]!.method = 2219;
            }
        }
    }

    /**
     * The initial grid state of this grid.
     */
    public gridState?: TTGridState;

    private initialPaginationState?: GridState['pagination'];

    public prepareGridStateForInitialization(state?: TTGridState): void {
        this.initialPaginationState = state?.pagination ? { ...state.pagination } : undefined;
        this.gridState = state ? { ...state } : undefined;

        delete this.gridState?.pagination;
    }

    private restoreInitialPaginationState(): void {
        const paginationState = this.initialPaginationState;
        const gridApi = this.gridApi;

        if (!paginationState || !gridApi || gridApi.isDestroyed()) return;

        this.initialPaginationState = undefined;

        if (paginationState.pageSize && paginationState.pageSize !== gridApi.paginationGetPageSize()) {
            gridApi.setGridOption('paginationPageSize', paginationState.pageSize);
        }

        if (typeof paginationState.page === 'number') {
            gridApi.paginationGoToPage(paginationState.page);
        }
    }

    /**
     * Whether the initial grid state has been retrieved, if any. Needed before the grid is rendered in template.
     */
    public gridStateReady = false;

    /**
     * Retrieves the grid state.
     */
    private async getGridState(columns?: ColDef[]) {
        this.gridStateReady = false;
        this.cdr.markForCheck();

        try {
            if (this.ttOptions.dataTask?.rememberId) {
                const state = (await this.gridService.getRemember(this.ttOptions.dataTask.rememberId)) as any;

                if (state?.agGrid === true) {
                    this.options.data!.layoutKeyno = state.gridlayout_keyno;
                    this.defaultColumnDefinitions.wrapText = state.wrapText ?? false;
                    this.defaultColumnDefinitions.wrapHeaderText = state.wrapHeaderText ?? false;
                    this.gridState = state;
                } else if (!!state) {
                    this.gridState = userSettingsToGridState(state, columns);
                }

                if (this.options.kendo?.sortable === false) {
                    delete this.gridState?.sort;
                }

                if (!this.isFilterable() && !!this.gridState) {
                    this.gridState.floatingFilter = false;
                    delete this.gridState.filter;
                }

                let columnsToHide =
                    columns
                        ?.filter((colDef) => colDef.hide === true)
                        .map((colDef) => colDef.colId!)
                        .filter((colId) => !state.columnOrder?.orderedColIds.includes(colId!) && colId !== 'grid_functions') ?? [];

                if (this.gridState?.columnVisibility) {
                    this.gridState.columnVisibility.hiddenColIds.push(...columnsToHide);
                }

                if (this.gridState?.columnOrder) {
                    this.gridState.columnOrder.orderedColIds.push(...columnsToHide);
                }

                if (this.options.data?.hasLockVisibleColumn) {
                    let lockedHiddenColumns = this.options.data.columnDefinitions.filter((col) => col.lockVisible === true && col.hide === true);
                    let lockedVisibleColumns = this.options.data.columnDefinitions.filter((col) => col.lockVisible === true && col.hide === false);

                    if (this.gridState?.columnVisibility?.hiddenColIds) {
                        this.gridState.columnVisibility.hiddenColIds = this.gridState.columnVisibility.hiddenColIds.filter((colid) => !lockedVisibleColumns.map((column) => column.colId).includes(colid));
                        this.gridState.columnVisibility.hiddenColIds.push(...lockedHiddenColumns.map((col) => col.colId!));
                    }
                }

                if (!!this.gridState && !this.gridState.columnPinning) {
                    this.gridState.columnPinning = { leftColIds: [], rightColIds: [] };
                }

                if (!!this.gridState?.columnPinning?.leftColIds && !this.gridState.columnPinning.leftColIds.includes('grid_functions')) {
                    if (this.gridState.columnVisibility?.hiddenColIds.includes('grid_functions')) this.gridState.columnVisibility.hiddenColIds = this.gridState.columnVisibility.hiddenColIds.filter((colId) => colId !== 'grid_functions');
                    if (!this.gridState.columnOrder!.orderedColIds.includes('grid_functions')) this.gridState.columnOrder!.orderedColIds = ['grid_functions', ...this.gridState.columnOrder!.orderedColIds];
                    this.gridState.columnPinning.leftColIds.push('grid_functions');
                }

                if (this.gridState?.filter?.filterModel) this.gridState.filter.filterModel = getDecodedFilterModel(this.gridState.filter.filterModel);
                if (this.gridState?.sort?.sortModel) this.gridState.sort.sortModel = this.gridState.sort.sortModel.filter((model) => !!model && 'colId' in model && 'sort' in model);
                delete this.gridState?.focusedCell;
                this.defaultColumnDefinitions.floatingFilter = this.gridState?.floatingFilter ?? true;

                this.prepareGridStateForInitialization(this.gridState);
                console.log(this.gridState);
            }
        } catch (error) {
            console.error(error);
            this.prepareGridStateForInitialization(undefined);
        } finally {
            this.gridStateReady = true;
            this.cdr.markForCheck();
        }
    }

    /**
     * Persists the current grid state.
     */
    public rememberGridState = (gridState: TTGridState | null = null) => {
        if (this.ttOptions.dataTask?.rememberId && this.gridApi) {
            let state: TTGridState = JSON.parse(JSON.stringify(gridState)) ?? JSON.parse(JSON.stringify({ ...this.gridApi.getState() }));

            if (state) {
                state = { ...state, floatingFilter: this.defaultColumnDefinitions.floatingFilter, agGrid: true, gridlayout_keyno: this.options.data?.layoutKeyno };
                delete state.focusedCell;

                if (state?.filter?.filterModel) {
                    state.filter.filterModel = getEncodedFilterModel(state.filter.filterModel);
                }

                this.gridService.saveUserSettings({ variablename: this.ttOptions.dataTask.rememberId, variablevalue: <TTGridState>{ ...state, floatingFilter: this.defaultColumnDefinitions.floatingFilter, agGrid: true, wrapText: this.defaultColumnDefinitions.wrapText, wrapHeaderText: this.defaultColumnDefinitions.wrapHeaderText } }) as GridState;
            }
        }
    };

    // #region ANGULAR COMPONENT LIFECYCLE

    ngOnInit(): void {
        this.popupParent = this.resolvePopupParent();

        if (!!this.appSettings?.settings?.agGridLicense) LicenseManager.setLicenseKey(this.appSettings.settings.agGridLicense);

        this.userStore.languageIdChanged.pipe(takeUntil(this.destroy$)).subscribe((languageId) => (this.localeText = this.gridService.getLocaleText(languageId)));

        if (this.ttOptions) this.setupOptionsFromTTOptions();
    }

    /**
     * Keeps menu popups above the active Material dialog without using its
     * offset pane as the coordinate origin. Page grids use the document body
     * and therefore cannot target AI chat.
     */
    private resolvePopupParent(): HTMLElement {
        const dialogPane = this.elementRef.nativeElement.closest<HTMLElement>('.cdk-overlay-pane');

        if (dialogPane) {
            return this.createDialogPopupHost(dialogPane);
        }

        return this.elementRef.nativeElement.closest<HTMLElement>('.modal') ?? document.body;
    }

    /**
     * AG Grid positions menu popups from the viewport. The Material dialog
     * pane is offset, so a fixed host inside that pane preserves the viewport
     * coordinate system and its stacking context.
     */
    private createDialogPopupHost(dialogPane: HTMLElement): HTMLElement {
        const host = this.renderer.createElement('div') as HTMLElement;
        this.renderer.addClass(host, 'tt-grid__popup-host');
        this.renderer.appendChild(dialogPane, host);
        this.popupHost = host;

        return host;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttShowHeaderMenuButton']) {
            this.ttShowHeaderMenuButton = changes['ttShowHeaderMenuButton'].currentValue;
            this.defaultColumnDefinitions = { ...this.defaultColumnDefinitions, suppressHeaderMenuButton: !this.ttShowHeaderMenuButton };
        }

        if (changes?.['ttOptions']?.isFirstChange() === false) {
            this.setupOptionsFromTTOptions();
        }

        if (changes['ttRowSelection']) {
            this.ttRowSelection = changes['ttRowSelection'].currentValue;
        }
    }

    ngOnDestroy(): void {
        clearTimeout(this.pivotColumnOrderTimeout);
        this.popupHost?.remove();
        this.readDataResolve?.([]);
        delete this.readDataResolve;
        this.destroy$.next();
        this.destroy$.complete();
        this.gridApi = undefined;
        this.clearCellSaveHighlights();
        this.gridService.activeGridId = null;
        this.layout.getMediaQueries().tablet.removeEventListener('change', this.setTheme);
        this.mobileThemeSubscription?.unsubscribe();
        this.desktopThemeSubscription?.unsubscribe();
        this.postSaveCoordinator.destroy();
    }

    // #endregion ANGULAR COMPONENT LIFECYCLE

    // #region GRID FUNCTIONS

    /**
     * Creates grid functions object and appends to `this.options.gridfunc` property.
     */
    private createGridFunctions() {
        this.options.gridfunc = {
            /* ok */ addRowAfter: (atIndex: number, dataItem?: TType) => this.addRow({ index: atIndex, addBefore: false, rowItem: dataItem }),
            /* ok */ addRowBefore: (atIndex: number, dataItem?: TType) => this.addRow({ index: atIndex, addBefore: true, rowItem: dataItem }),
            /* ok */ callPopupTable: (data: Record<string, unknown>[]) => this.gridModalService.openPopupTableModal(data),
            /* ok */ clearFilter: () => this.gridApi?.setFilterModel(null),
            /* ok */ clearSorting: () => this.gridApi?.applyColumnState({ defaultState: { sort: null } }),
            /* ok */ editCell: (rowIndex: number, colIndex: number) => this.editCell({ rowIndex: rowIndex, columnIndex: colIndex }),
            /* ok */ startCellEditing: (params: StartCellEditingParams) => this.startCellEditing(params),
            /* ok */ getAllRows: () => this.getRows(),
            /* ok (deprecated) */ getColumnFormatType: (key) => '',
            /* ok */ getColumnSchema: () => this.options.data!.columnInfo!,
            /* ok */ getColumnState: () => this.gridApi?.getColumnState() || [],
            /* ok */ getDataItem: (atIndex?: number) => (atIndex !== undefined ? this.gridApi!.getDisplayedRowAtIndex(atIndex) : this.gridApi!.getDisplayedRowAtIndex(0)) || null,
            /* ok */ getDataItems: () => this.gridApi!.getRenderedNodes().map((node) => node.data),
            /* ok (deprecated) */ getDataSource: () => ({ sort: () => [] }),
            /* ok */ getDirtyRows: () => this.getRows(true),
            /* ok (deprecated) */ getGrid: () => ({}),
            /* ok */ getGridApi: () => this.gridApi!,
            /* ok */ getGridColumns: () => this.options.data!.columnDefinitions,
            /* ok (deprecated) */ getResponse: () => [],
            /* ok (deprecated) */ getResponseColumns: () => [],
            /* ok */ getRowAt: (index: number) => this.gridApi!.getDisplayedRowAtIndex(index) || null,
            /* ok */ getRows: (dirty: boolean = false, filtered: boolean = false, sorted: boolean = false) => this.getRows(dirty, filtered, sorted),
            getRowIndex: (row: TType) => this.getRowNode({ row: row })?.rowIndex ?? -1,
            getRowNode: (row: TType) => this.getRowNode({ row: row }),
            /* ok */ getSelectedRow: () => (this.gridApi!.getSelectedRows().length === 1 ? this.gridApi!.getSelectedRows()[0] : this.gridApi!.getSelectedRows()),
            /* ok */ getSelectedRows: () => this.gridApi!.getSelectedRows(),
            getIsSelectedRows: (dirty: boolean = false, filtered: boolean = false, sorted: boolean = false) => this.getRows(dirty, filtered, sorted).filter((value) => value?.['is_selected'] === true),
            /* ok */ gridProgress: (spin: boolean = true) => (spin === true ? this.gridApi?.showLoadingOverlay() : this.gridApi?.hideOverlay()),
            /* ok */ hasRows: () => this.getRows().length > 0,
            /* ok */ isReady: () => this.gridApi !== undefined,
            /* ok */ read: (options: boolean | GridReadOptions = true) => this.readData(options),
            redrawRow: (_, row) => this.redrawRow({ row: row }),
            /* ok */ rebind: async (newDataTaskColumns: boolean = true) => this.reloadData(true, newDataTaskColumns) as Promise<void>,
            /* ok */ refresh: () => this.refreshData(),
            /* ok */ refreshAggregates: () => this.updateAggregationRow(),
            refreshCellEditability: (rowIds?: string[] | null, colIds?: string[] | null) => this.refreshCellEditability(rowIds, colIds),
            /* ok */ refreshToolbarBtnDisability: (refreshFromColschema: boolean = false) => this.refreshToolbar.next(refreshFromColschema),
            /* ok */ removeRow: (dataItem: TType) => this.removeRow(dataItem, true, true, true),
            /* ok */ removeRows: () => this.removeSelectedRows(),
            /* ok */ resize: () => console.log('gridfunc.resize() => nothing to resize for now...'),
            /* ok */ saveChanges: (showProgress: boolean = true) => this.saveAllChanges(showProgress),
            saveSingleRow: (row: TType, state: ChangeState) => this.gridService.saveSingleRow({ state: state, row: row, gridApi: this.gridApi, options: this.options, refreshRow: true, rowIndex: this.getRowNode({ row: row })?.rowIndex ?? null, event: 'unknown', rowIdOver: null, direction: null }),
            /* ok */ selectRow: (index: number) => this.gridApi?.getDisplayedRowAtIndex(index)?.setSelected(true, true),
            /* ok */ setDataSource: (newDataSource: TType[]) => this.setRowData(newDataSource),
            /* ok */ setFocusToCell: (rowIndex: number, colIndex) => this.setFocusedCell({ rowIndex: rowIndex, columnIndex: colIndex }),
            /* ok */ test: (p1: unknown, p2: unknown) => '',
            /* ok */ updateRow: (row: TType | null, rowIdx?: number) => this.redrawRow({ row: row, rowIndex: rowIdx }),
            viewMatching: (criteria: string | undefined, value: unknown) => this.viewMatching(criteria ?? '', value),
        };
    }

    /**
     * Retrieves the list of rows. If dirty is true, only dirty rows are returned, if filtered is true, only filtered rows are returned, if sortes is
     * true the list is sorted according to the current sort state.
     *
     * @param dirty whether the list should only contain dirty rows.
     * @param filtered whether the list should only contain the filtered rows.
     * @param sorted whether the list should be sorted according to the current sort state of the grid.
     * @returns list of row-data.
     */
    private getRows(dirty: boolean = false, filtered: boolean = false, sorted: boolean = false) {
        let data = [...this.options.data!.rowData];

        if (filtered && !sorted) {
            data = [];
            this.gridApi?.forEachNodeAfterFilter((rowNode) => data.push(rowNode.data));
        } else if (filtered && sorted) {
            data = [];
            this.gridApi?.forEachNodeAfterFilterAndSort((rowNode) => data.push(rowNode.data));
        }

        if (dirty) data = data.filter((row) => row._dirty === true);
        if (filtered && !sorted) data = this.sortData(data);

        return data;
    }

    /**
     * Sorts the given data according to the current column state of the grid
     *
     * @param data the data to sort.
     * @returns the data list after sorting.
     */
    private sortData(data: TType[]) {
        this.gridApi!.getColumnState()
            .filter((state) => !!state.sort)
            .forEach((state) => {
                data.sort((a, b) => {
                    const valueA = a[state.colId];
                    const valueB = b[state.colId];
                    if (valueA === valueB) return 0;

                    const sortDirection = state.sort === 'asc' ? 1 : -1;
                    return valueA > valueB ? sortDirection : sortDirection * -1;
                });
            });

        return data;
    }

    /**
     * Starts cell editing on the cell matching the given row and column parameters.
     *
     * @param param0 row and column parameters of the cell to start editing on, only one for row and one for column is required, not all.
     */
    private editCell({ row, rowIndex, rowId, columnIndex, columnKey }: { row?: TType | null; rowIndex?: number | null; rowId?: string | null; columnIndex?: number | null; columnKey?: string | null }) {
        if (this.postSaveRunning === true) return;

        // TODO: theres a startCellEditing function, try and merge these.
        const rowNode = this.getRowNode({ row: row, rowIndex: rowIndex, rowId: rowId });
        let colKey = columnKey ?? null;

        if (columnIndex !== undefined && columnIndex !== null && !colKey) {
            colKey = this.gridApi?.getColumnState()?.filter((column) => column.hide !== true)?.[columnIndex]?.colId ?? null;
        }

        if (!!rowNode && rowNode.rowIndex !== null && !!colKey) {
            this.gridApi?.startEditingCell({ rowIndex: rowNode.rowIndex, colKey: colKey });
        }
    }

    /**
     * Gets the page number (zero-based) for the row at the given row index.
     *
     * @param rowIndex the index of the row to get page of.
     * @returns zero-based page number for the row index.
     */
    private getPageForRowIndex(rowIndex: number): number {
        const pageSize = this.gridApi!.paginationGetPageSize();

        if (rowIndex !== undefined && rowIndex !== null && !isNaN(+rowIndex)) {
            return Math.floor(rowIndex / pageSize);
        } else {
            throw Error('rowIndex is needed for finding page');
        }
    }

    /**
     * Sets the focused cell to the cell which matches the row parameter provided and the column parameter provided,
     *
     * @param param0 the row and column of the cell to focus.
     */
    private setFocusedCell({ row, rowIndex, rowId, columnIndex, columnKey }: { row?: TType | null; rowIndex?: number | null; rowId?: string | null; columnIndex?: number | null; columnKey?: string | null }) {
        let indexOfRow = rowIndex ?? this.getRowNode({ row: row, rowId: rowId, rowIndex: rowIndex })?.rowIndex ?? null;
        let colKey = columnKey ?? null;

        if (columnIndex !== undefined && columnIndex !== null && !colKey) colKey = this.options.data?.columnDefinitions?.filter((column) => column.hide !== true)?.[columnIndex]?.colId ?? null;
        if (indexOfRow !== null && colKey !== null) this.gridApi?.setFocusedCell(indexOfRow, colKey, null);
    }

    /**
     * Redraws the row which matches the given row parameters.
     *
     * @param param0 the row of which to redraw, only one is necessary, `row` takes precedence, then `rowIndex`, then `rowId`.
     */
    private redrawRow({ row, rowIndex, rowId }: { row?: TType | null; rowIndex?: number; rowId?: string }) {
        let rowNode: IRowNode | null = null;

        if (!!row) {
            rowNode = this.gridApi?.getRowNode(row._uuid || '') || null;
        } else if (rowIndex !== undefined && rowIndex !== null) {
            rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex) || null;
        } else if (!!rowId && typeof rowId === 'string') {
            rowNode = this.gridApi?.getRowNode(rowId) || null;
        }

        if (!!rowNode) {
            const index = this.options.data!.rowData.findIndex((r) => r._uuid === row?._uuid);

            if (index !== -1) {
                this.options.data!.rowData[index] = { ...this.options.data!.rowData[index], ...row };
            }
            rowNode.data = row;
            rowNode.setData({ _uuid: rowNode.id, ...row });

            if (!!rowNode.data) updateActiveCellEditorFromGridRow(this.options);
        }
    }

    /**
     * Sets the given rowData as the rowdata of the grid, then redraws the grid.
     *
     * @param rowData the rowdata to set in the grid.
     */
    private setRowData(rowData: TType[]): void {
        if (!rowData) rowData = [];

        this.clearCellSaveHighlights();

        if (rowData.some((row) => Object.hasOwn(row, '_uuid') === false)) {
            this.options.data!.rowData = this.mapDataToGridRows(rowData);
        } else {
            this.options.data!.rowData = rowData;
        }

        this.gridApi?.setGridOption('rowData', this.options.data!.rowData);
        this.refreshCellEditability();
        this.updateAggregationRow();

        if (this.ttOptions.gridfunc) {
            this.refreshToolbar.next();
        }
    }

    /**
     * Retrieves the row node matching the given parameters. `rowId` takes precedence over `roIndex`, and `rowIndex` takes precedence over `row`.
     *
     * @param param0 the row information of which to retireve row node for, only one parameters is required.
     * @returns the row node matching the given parameters.
     */
    private getRowNode({ row, rowIndex, rowId }: { row?: TType | null; rowIndex?: number | null; rowId?: string | null }): IRowNode | null {
        let rowNode: IRowNode | null = null;

        if (!!rowId) {
            rowNode = this.gridApi?.getRowNode(rowId) ?? null;
        } else if (rowIndex !== undefined && rowIndex !== null) {
            rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex) ?? null;
        } else if (!!row && !!row._uuid) {
            rowNode = this.gridApi?.getRowNode(row._uuid) ?? null;
        }

        return rowNode;
    }

    /**
     * Rerenders the grid to only display rows which has a property of the given keyname whose value equals the given value.
     *
     * @param keyname the keyname of the property in the rows to match with.
     * @param value the value to match the value of the property with.
     */
    private viewMatching(keyname: string, value: unknown) {
        if (this.options.data?.rowData.length === 0) this.gridApi?.setGridOption('rowData', this.options.data.rowData);

        if (keyname === '') {
            this.gridApi?.setGridOption('rowData', this.options.data!.rowData);
        } else if (!!keyname) {
            const matchingData = [];

            for (let row of this.options.data!.rowData) if (row[keyname] === value) matchingData.push(row);

            if (matchingData.length > 0) this.gridApi?.setGridOption('rowData', matchingData);
        }
    }

    // #endregion GRID FUNCTIONS

    processCellForClipboard = (params: ProcessCellForExportParams) => {
        if (params.value instanceof Date && this.isValidDate(params.value)) {
            return formatDate(params.value, 'yyyy-MM-dd' + ' HH:mm:ss', DATE_FORMATS.display.dateInput.language || navigator.language || navigator.languages[0] || 'nb-NO');
        } else if (!!params.value && typeof params.value === 'object') {
            return JSON.stringify(params.value);
        } else {
            return params.value;
        }
    };

    private isValidDate(date: unknown): date is Date {
        return date instanceof Date && !isNaN(date.getTime());
    }

    private getDateFromExcelSerial(serial: number): Date | null {
        if (!Number.isFinite(serial) || serial < 1 || serial > 2958465) return null;

        const wholeDays = Math.floor(serial);
        const dayFraction = serial - wholeDays;
        const date = new Date(1899, 11, 30);

        date.setDate(date.getDate() + wholeDays);

        if (dayFraction > 0) {
            date.setSeconds(Math.round(dayFraction * 86400));
        }

        return this.isValidDate(date) ? date : null;
    }

    private parseClipboardDate(value: unknown): Date | null {
        const dateString = `${value ?? ''}`
            .trim()
            .replace(/\u00A0/g, ' ')
            .replace(/\s+/g, ' ');

        if (!dateString) return null;

        if (/^\d+([,.]\d+)?$/.test(dateString)) {
            const excelDate = this.getDateFromExcelSerial(Number(dateString.replace(',', '.')));

            if (excelDate) return excelDate;
        }

        const localDateMatch = dateString.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{2,4})(?:,?\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);

        if (localDateMatch) {
            const year = Number(localDateMatch[3].length === 2 ? '20' + localDateMatch[3] : localDateMatch[3]);
            const month = Number(localDateMatch[2]) - 1;
            const day = Number(localDateMatch[1]);
            const hours = Number(localDateMatch[4] ?? 0);
            const minutes = Number(localDateMatch[5] ?? 0);
            const seconds = Number(localDateMatch[6] ?? 0);
            const date = new Date(year, month, day, hours, minutes, seconds);

            if (this.isValidDate(date) && date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) return date;
        }

        const parsedDate = this.dateAdapter.parse(dateString.split(' ')[0], DATE_FORMATS.display.dateInput);

        if (this.isValidDate(parsedDate)) return parsedDate;

        const nativeDate = new Date(dateString);

        return this.isValidDate(nativeDate) ? nativeDate : null;
    }

    processCellFromClipboard = (params: ProcessCellForExportParams) => {
        this.gridApi?.setGridOption('context', 'paste');

        if (params.column.getColDef().cellDataType === 'date') {
            return this.parseClipboardDate(params.value) ?? params.value;
        } else if (params.column.getColId()?.endsWith('_chips')) {
            return JSON.parse(params.value);
        } else if (params.column.getColDef().cellDataType === 'datetime') {
            return this.parseClipboardDate(params.value) ?? params.value;
        } else if (params.column.getColDef().cellDataType === 'number') {
            let validCharacters = new RegExp(/[^0-9.,-]/g);
            let number = Number(
                ('' + params.value)
                    .replaceAll(/\,/g, '.')
                    .replaceAll(/−/g, '-')
                    .replaceAll(/—/g, '-')
                    .replace(/\s/g, ' ')
                    .replace(validCharacters, '')
                    .replace(/(?!^)-/g, '')
                    .replace(/^([^.]*\.)(.*)$/, (a, b, c) => b + c.replace(/\./g, '')),
            );

            if (!isNaN(number)) {
                return number;
            }

            return null;
        }

        return params.value;
    };

    processDataFromClipboard = (params: ProcessDataFromClipboardParams) => {
        const rowCount = this.gridApi?.getDisplayedRowCount();
        const focusedCell = this.gridApi?.getFocusedCell();
        const pastedData = params.data.filter((row) => row.length >= 1 && !!row[0]);
        const pastedRowsLength = pastedData.length;
        const rowsLeftFromPastedCell = rowCount! - (focusedCell!.rowIndex! + pastedRowsLength);
        const newRowsToAdd = rowsLeftFromPastedCell < 0 ? Math.abs(rowsLeftFromPastedCell) : 0;
        const range: CellRange[] | null | undefined = this.gridApi?.getCellRanges();

        if (newRowsToAdd > 0 && !!range && range[0].columns.length === 1 && range[0].startRow?.rowIndex === range[0].endRow?.rowIndex) {
            let rowsToAdd: any[] = [];

            for (let i = 0; i < newRowsToAdd; i++) {
                const row = pastedData.slice(i, i + 1)[0];
                const rowObject: GridRow = { ...this.createNewRow(), _uuid: crypto.randomUUID() };
                let currentColumn: any = focusedCell!.column;
                const pastedColumns: string[] = [];

                row.forEach((item) => {
                    if (!currentColumn) return;

                    const field = currentColumn.colDef.field;

                    rowObject[field] = item;
                    pastedColumns.push(field);
                    currentColumn = params.api!.getDisplayedColAfter(currentColumn);
                });

                this.options.data!.changes![rowObject._uuid!]! = { state: 'add', data: rowObject as TType, event: 'paste', rowIndex: null, rowOverId: null, direction: null };
                this.options.data!.dirtyRows[rowObject._uuid!] = { cells: pastedColumns };
                this.markCellsSaveHighlight(rowObject._uuid, pastedColumns, 'pending');
                rowsToAdd.push(rowObject);
            }

            this.options.data?.rowData.push(...(rowsToAdd as TType[]));
            this.gridApi?.applyTransaction({ add: rowsToAdd });
            this.refreshCellEditability(rowsToAdd.map((row) => row._uuid));
        }

        return pastedData;
    };

    private getHeaderElement(): HTMLDivElement | undefined | null {
        // @ts-ignore _nativeElement is a property of AgGridAngular
        return this.agGrid?._nativeElement.querySelector('.ag-header');
    }
}
